var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeamHeroCropped(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 47.34 750 420.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 567.809,
    y: 65.2042,
    width: 56.75249,
    height: 106.9911,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 555.11169,
    y: 65.2042,
    width: 66.6649,
    height: 106.9911,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 565.24429,
    y: 74.7074,
    width: 46.3681,
    height: 87.9844,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 579.99329,
    y: 100.948,
    width: 18.0266,
    height: 34.1974,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 123.76004,
    y: 65.2042,
    width: 56.75246,
    height: 106.9911,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.0627,
    y: 65.2042,
    width: 66.6649,
    height: 106.9911,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.19533,
    y: 74.7074,
    width: 46.36807,
    height: 87.9844,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.9443,
    y: 100.948,
    width: 18.0266,
    height: 34.1974,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M673.73379,322.3374h-180.7461c-3.2324,0-5.8623-2.6298-5.8623-5.8623V53.2017c0-3.2324,2.6299-5.8617,5.8623-5.8617h180.7461c3.2323,0,5.86221,2.6293,5.86221,5.8617V316.4751c0,3.2325-2.62991,5.8623-5.86221,5.8623ZM492.98769,47.59c-3.09469,0-5.6123,2.5175-5.6123,5.6117V316.4751c0,3.0948,2.51761,5.6123,5.6123,5.6123h180.7461c3.0946,0,5.61221-2.5175,5.61221-5.6123V53.2017c0-3.0942-2.51761-5.6117-5.61221-5.6117h-180.7461Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.30609,322.3374h-180.7466c-3.2324,0-5.8618-2.6298-5.8618-5.8623V53.2017c0-3.2324,2.6294-5.8617,5.8618-5.8617h180.7466c3.2324,0,5.8623,2.6293,5.8623,5.8617V316.4751c0,3.2325-2.6299,5.8623-5.8623,5.8623ZM284.5595,47.59c-3.0942,0-5.6118,2.5175-5.6118,5.6117V316.4751c0,3.0948,2.5176,5.6123,5.6118,5.6123h180.7466c3.0947,0,5.6123-2.5175,5.6123-5.6123V53.2017c0-3.0942-2.5176-5.6117-5.6123-5.6117h-180.7466Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.0123,322.3374H76.2658c-3.2324,0-5.8618-2.6298-5.8618-5.8623V53.2017c0-3.2324,2.6294-5.8617,5.8618-5.8617h180.7465c3.2324,0,5.8623,2.6293,5.8623,5.8617V316.4751c0,3.2325-2.6299,5.8623-5.8623,5.8623ZM76.2658,47.59c-3.0942,0-5.6118,2.5175-5.6118,5.6117V316.4751c0,3.0948,2.5176,5.6123,5.6118,5.6123h180.7465c3.0948,0,5.6123-2.5175,5.6123-5.6123V53.2017c0-3.0942-2.5175-5.6117-5.6123-5.6117H76.2658Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    y: 383.4068,
    width: 750,
    height: 0.1204,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 653.62639,
    y: 412.7829,
    width: 55.7291,
    height: 0.4206,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 495.04359,
    y: 417.3486,
    width: 14.6268,
    height: 0.4206,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.6445,
    y: 399.9856,
    width: 72.6745,
    height: 0.4207,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.2991,
    y: 399.9856,
    width: 10.6555,
    height: 0.4207,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.5856,
    y: 407.0897,
    width: 157.61289,
    height: 0.4206,
    style: {
      fill: "#ebebeb"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M238.4796,111.2354c-2.5069,3.8172-4.1926,8.0104-5.0908,12.3355l-6.8884,.6487-.0006,13.34,6.8892,.6489c.8974,4.3242,2.5837,8.5172,5.0906,12.3356l-4.3998,5.314,9.4331,9.4329,5.3142-4.3994c3.818,2.5065,8.0108,4.1928,12.3352,5.09l.6485,6.8892,13.34-.0008,.649-6.8876c4.3248-.8984,8.518-2.5843,12.336-5.0908l5.3139,4.3994,9.4334-9.4329-4.3994-5.3144c2.5061-3.818,4.1924-8.0108,5.0899-12.3352l6.8877-.6489,.001-13.34-6.8882-.6494c-.898-4.324-2.5847-8.5168-5.0912-12.3344l4.3994-5.3145-9.433-9.4328-5.3139,4.3994c-3.8184-2.5065-8.0114-4.1936-12.3352-5.0912l-.649-6.8886-13.3404,.0006-.6485,6.8885c-4.3244,.8979-8.5172,2.5834-12.3348,5.0903l-5.3146-4.3998-9.4331,9.4334,4.3998,5.3143Zm42.772,6.8845c7.0516,7.0524,7.052,18.4874,0,25.5396-7.0531,7.0528-18.488,7.0524-25.5401,.0004-7.0526-7.0526-7.0522-18.4868,.0005-25.54,7.0524-7.0518,18.4865-7.0523,25.5396,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.5104,272.153c-1.2529,1.9078-2.0954,4.0035-2.5443,6.1651l-3.4428,.3242-.0003,6.6672,3.4432,.3243c.4485,2.1612,1.2913,4.2568,2.5442,6.1652l-2.199,2.6558,4.7146,4.7145,2.6559-2.1988c1.9082,1.2528,4.0037,2.0955,6.165,2.5439l.3241,3.4432,6.6672-.0004,.3243-3.4424c2.1615-.449,4.2572-1.2915,6.1654-2.5443l2.6558,2.1988,4.7147-4.7145-2.1988-2.656c1.2526-1.9082,2.0953-4.0037,2.5439-6.165l3.4424-.3243,.0005-6.6672-3.4427-.3245c-.4488-2.1611-1.2917-4.2566-2.5445-6.1646l2.1988-2.6561-4.7145-4.7144-2.6558,2.1988c-1.9084-1.2528-4.004-2.0959-6.165-2.5445l-.3243-3.4429-6.6674,.0003-.3241,3.4428c-2.1613,.4488-4.2568,1.2911-6.1648,2.5441l-2.6561-2.199-4.7146,4.7147,2.199,2.656Zm21.3768,3.4408c3.5243,3.5247,3.5246,9.2397,0,12.7643-3.525,3.525-9.24,3.5247-12.7645,.0002-3.5248-3.5248-3.5246-9.2394,.0002-12.7645,3.5247-3.5244,9.2393-3.5246,12.7643,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4591,202.5617c-1.9789,3.0133-3.3096,6.3233-4.0186,9.7375l-5.4378,.5121-.0004,10.5305,5.4384,.5122c.7083,3.4136,2.0395,6.7235,4.0184,9.7377l-3.4732,4.1947,7.4465,7.4464,4.1949-3.4729c3.0139,1.9787,6.3236,3.3097,9.7373,4.0179l.5119,5.4384,10.5306-.0006,.5122-5.4371c3.414-.7092,6.7241-2.0399,9.738-4.0186l4.19471,3.4729,7.44666-7.4464-3.47291-4.195c1.97843-3.0139,3.30944-6.3237,4.01798-9.7374l5.43713-.5122,.00079-10.5305-5.43759-.5126c-.70887-3.4133-2.0402-6.7231-4.01894-9.7367l3.47291-4.1952-7.44635-7.4462-4.19469,3.4729c-3.0143-1.9787-6.3242-3.3104-9.7374-4.0189l-.5122-5.4379-10.5309,.0005-.5119,5.4377c-3.4137,.7089-6.7234,2.0393-9.737,4.0183l-4.1952-3.4732-7.4465,7.4467,3.4732,4.195Zm33.7637,5.4346c5.5665,5.5671,5.567,14.5937,0,20.1607-5.5675,5.5675-14.5941,5.5671-20.1609,.0003-5.5673-5.5673-5.567-14.5933,.0003-20.161,5.5671-5.5667,14.5931-5.567,20.1606,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.88889,181.0437c-.9262,1.4103-1.549,2.9596-1.8808,4.5575l-2.54509,.2397-.00021,4.9287,2.5453,.2397c.3316,1.5977,.9546,3.1469,1.8808,4.5577l-1.6256,1.9632,3.4853,3.4852,1.9633-1.6254c1.4107,.9261,2.9598,1.5491,4.5575,1.8805l.23961,2.5454,4.92869-.0003,.2397-2.5448c1.5979-.3319,3.1472-.9547,4.5578-1.8808l1.9633,1.6254,3.4853-3.4852-1.6255-1.9634c.926-1.4106,1.549-2.9597,1.8806-4.5575l2.5448-.2397,.0004-4.9287-2.545-.2399c-.3318-1.5976-.9549-3.1467-1.881-4.5571l1.6254-1.9636-3.4852-3.4851-1.96329,1.6255c-1.41071-.9261-2.95991-1.5494-4.55741-1.881l-.2398-2.5452-4.92879,.0002-.23961,2.5451c-1.5977,.3318-3.1468,.9545-4.5573,1.8807l-1.9635-1.6256-3.4853,3.4854,1.6256,1.9634Zm15.8028,2.5436c2.60531,2.6056,2.6055,6.8304,0,9.436-2.6059,2.6058-6.83069,2.6056-9.4362,.0001-2.6057-2.6057-2.60549-6.8302,.0002-9.4361,2.6056-2.6054,6.8301-2.6055,9.436,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.93969,119.4c-.9262,1.4103-1.549,2.9596-1.8809,4.5575l-2.545,.2397-.0003,4.9287,2.5454,.2397c.3316,1.5977,.9546,3.1469,1.8808,4.5576l-1.6256,1.9633,3.4853,3.4852,1.9633-1.6255c1.4106,.9262,2.9597,1.5491,4.5575,1.8806l.2396,2.5454,4.9287-.0003,.2397-2.5448c1.5979-.3319,3.1471-.9547,4.55781-1.8809l1.96329,1.6255,3.4853-3.4852-1.6255-1.9634c.926-1.4106,1.549-2.9597,1.8806-4.5575l2.5448-.2397,.0004-4.9287-2.5451-.2399c-.3317-1.5976-.95479-3.1467-1.881-4.5572l1.6255-1.9635-3.4852-3.4851-1.9633,1.6255c-1.41079-.9262-2.9599-1.5494-4.5574-1.881l-.2398-2.5452-4.9288,.0002-.2396,2.5451c-1.5978,.3318-3.1469,.9544-4.5573,1.8807l-1.9635-1.6256-3.4853,3.4853,1.6256,1.9635Zm15.8027,2.5436c2.6054,2.6056,2.60561,6.8304,0,9.436-2.6058,2.6058-6.8306,2.6056-9.4361,.0001-2.6057-2.6057-2.6055-6.8302,.0002-9.4361,2.6056-2.6054,6.8301-2.6056,9.4359,0Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.07589,260.8633c-.9262,1.4104-1.54901,2.9596-1.88086,4.5576l-2.54508,.2396-.00022,4.9287,2.54537,.2398c.33155,1.5976,.95459,3.1468,1.88079,4.5576l-1.6256,1.9633,3.48525,3.4852,1.96337-1.6255c1.41063,.9261,2.95969,1.5491,4.55749,1.8806l.2396,2.5453,4.9287-.0003,.2397-2.5447c1.5979-.332,3.1471-.9548,4.5578-1.8809l1.9633,1.6255,3.4853-3.4852-1.6255-1.9635c.926-1.4106,1.549-2.9597,1.8806-4.5574l2.5448-.2398,.0003-4.9287-2.545-.2399c-.3317-1.5975-.9548-3.1466-1.881-4.5571l1.6255-1.9635-3.4852-3.4851-1.9633,1.6254c-1.4108-.9261-2.9599-1.5494-4.5574-1.881l-.2398-2.5452-4.9288,.0003-.2396,2.545c-1.5978,.3318-3.14686,.9545-4.55734,1.8808l-1.96352-1.6256-3.48525,3.4853,1.6256,1.9634Zm15.80271,2.5436c2.6054,2.6057,2.6056,6.8305,0,9.436-2.6058,2.6058-6.8306,2.6056-9.4361,.0002-2.60569-2.6057-2.60554-6.8302,.0002-9.4362,2.6056-2.6054,6.8301-2.6055,9.4359,0Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.99489,200.9233c-1.5918,2.4238-2.6622,5.0863-3.2325,7.8326l-4.374,.4119-.00039,8.4705,4.37459,.412c.5698,2.7458,1.6405,5.4082,3.2323,7.8328l-2.7938,3.3741,5.9898,5.9897,3.3743-2.7935c2.4243,1.5916,5.0866,2.6622,7.8325,3.2319l.4117,4.3745,8.47061-.0005,.412-4.3735c2.74609-.5704,5.40869-1.6408,7.833-3.2324l3.37409,2.7935,5.99-5.9897-2.7936-3.3744c1.5914-2.4243,2.6621-5.0866,3.232-7.8325l4.37351-.412,.00059-8.4705-4.3738-.4123c-.5702-2.7456-1.6411-5.4079-3.23279-7.832l2.79359-3.3745-5.9897-5.9896-3.3741,2.7936c-2.4246-1.5917-5.087-2.6628-7.8325-3.2328l-.4121-4.3741-8.4708,.0004-.4117,4.374c-2.7459,.5702-5.4082,1.6403-7.8323,3.2322l-3.3745-2.7938-5.9898,5.99,2.7938,3.3744Zm27.1588,4.3714c4.4775,4.4781,4.4779,11.7389,0,16.2168-4.4785,4.4784-11.7393,4.478-16.2171,.0002-4.4781-4.4781-4.4779-11.7384,.0003-16.217,4.47811-4.4777,11.7383-4.4779,16.2168,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.64129,248.4169c-1.60429,2.4426-2.683,5.1261-3.2578,7.8939l-4.4081,.4151-.00039,8.5366,4.40869,.4154c.5742,2.7671,1.65331,5.4504,3.2576,7.8939l-2.8156,3.4006,6.0365,6.0365,3.40081-2.8154c2.44319,1.6041,5.12639,2.6831,7.89369,3.2573l.415,4.4086,8.5367-.0005,.4153-4.4076c2.7676-.5749,5.4509-1.6537,7.8942-3.2578l3.4006,2.8154,6.0367-6.0365-2.8153-3.4008c1.6038-2.4433,2.6828-5.1264,3.2572-7.8937l4.4076-.4154,.0006-8.5366-4.4079-.4156c-.5747-2.767-1.654-5.4501-3.258-7.8932l2.8153-3.401-6.0365-6.0363-3.4005,2.8154c-2.4436-1.6041-5.1268-2.6836-7.89369-3.258l-.41541-4.4083-8.5369,.0004-.415,4.4081c-2.7673,.5747-5.4505,1.6532-7.8935,3.2575l-3.401-2.8156-6.0365,6.0368,2.8156,3.4008Zm27.3711,4.4055c4.51261,4.5131,4.5128,11.8307,0,16.3437-4.5135,4.5133-11.8311,4.513-16.3439,.0002-4.5132-4.5132-4.5128-11.8302,.0003-16.3439,4.51321-4.5126,11.8301-4.5129,16.3436,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.661,328.8822c-2.69221,4.0991-4.50241,8.6024-5.467,13.2471l-7.39751,.6967-.0008,14.3259,7.3986,.6969c.9636,4.6437,2.7745,9.1467,5.46671,13.2473l-4.725,5.7067,10.13029,10.1302,5.707-4.7246c4.1002,2.6918,8.6029,4.5027,13.2469,5.4661l.6965,7.3985,14.3259-.0009,.6969-7.3967c4.64451-.9648,9.1476-2.7752,13.2478-5.467l5.7066,4.7246,10.1307-10.1302-4.72459-5.7071c2.69139-4.1002,4.50219-8.6029,5.46609-13.2469l7.3967-.6969,.001-14.3259-7.3973-.6974c-.9643-4.6436-2.7756-9.1462-5.4674-13.246l4.7246-5.7074-10.1302-10.1299-5.7067,4.7246c-4.1006-2.6918-8.6036-4.5035-13.24679-5.4674l-.697-7.3979-14.32631,.0007-.6965,7.3976c-4.644,.9643-9.1467,2.7743-13.2465,5.4666l-5.7074-4.7251-10.13029,10.1306,4.725,5.7072Zm45.93319,7.3932c7.5727,7.5736,7.5732,19.8537,0,27.4272-7.5744,7.5741-19.8545,7.5736-27.4277,.0004-7.5739-7.5739-7.5733-19.853,.00051-27.4276,7.57369-7.5729,19.85279-7.5735,27.42719,0Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M700.51259,448.3939c0,3.3867-141.2598,6.1322-315.51259,6.1322s-315.5126-2.7455-315.5126-6.1322,141.2598-6.1323,315.5126-6.1323,315.51259,2.7455,315.51259,6.1323Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M117.07955,274.1558c-18.23575,21.331-23.56175,52.9055-13.33205,79.0381,11.36601-10.1444,19.36973-25.6071,19.87631-39.1315,.50669-13.5244-3.0333-26.8361-6.54426-39.9066Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.8983,355.6591c-6.1875,9.481-9.1493,21.0265-8.29,32.3153,9.85818-3.4322,18.54882-14.5676,23.75912-23.6128,5.21031-9.0452,8.12348-19.2046,10.77408-29.3009-10.67939,3.758-20.05568,11.1176-26.2432,20.5984Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.6241,311.40681c-7.32654,26.32729-11.05756,53.63561-11.03572,80.96474,.00621,7.77487,.32122,15.54683,.92873,23.29775,.03747,.47802,.78778,.48206,.75,0-2.13649-27.25838-.55116-54.78401,4.74163-81.61064,1.48959-7.54999,3.27545-15.03883,5.33857-22.45247,.1296-.46571-.59378-.66446-.72321-.19938h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.7223,396.89329c7.48399-17.81666,17.32351-34.50732,28.69676-50.10792,.28468-.39049-.36577-.76513-.6476-.37854-8.90328,12.21256-16.9028,25.08654-23.52305,38.68237-1.85917,3.81812-3.60472,7.68953-5.24931,11.60471-.18666,.44436,.53879,.63842,.72321,.19938h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1078,370.4322c5.1595,7.9057,7.6292,17.5328,6.9126,26.9457-8.2202-2.8618-15.4667-12.147-19.8111-19.6892-4.3447-7.5422-6.7737-16.0134-8.984-24.4321,8.9049,3.1337,16.7231,9.2701,21.8825,17.1756Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.4995,403.61591c-6.1388-14.60582-14.25227-28.14429-23.5733-40.92998-.28153-.38618-.93257-.01235-.6476,.37854,9.27895,12.72797,17.38602,26.20954,23.4977,40.75082,.1842,.43827,.91028,.24571,.72321-.19938h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.78757,408.46727c11.59977-11.9346,23.44468-23.62784,35.0445-35.5624,.3366-.34631-.19318-.87721-.53033-.53033-11.59982,11.93456-23.44473,23.6278-35.0445,35.5624-.3366,.34631,.19318,.87721,.53033,.53033h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.2687,367.4216c-10.06428,9.7058-19.23374,20.3392-27.3541,31.7213l1.8414,.0005c7.66005-.3593,15.09617-4.1382,19.90216-10.1138,4.80594-5.9756,6.90224-14.0491,5.61054-21.608Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M89.6281,344.27447c4.32123,7.06715,8.39267,14.28321,12.2071,21.6363,.22233,.4286,.86978,.04975,.6476-.37854-3.81443-7.35308-7.88587-14.56915-12.2071-21.6363-.2514-.41115-.90032-.03477-.6476,.37854h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.207,308.5939c-1.648,7.4127-3.2825,17.0523-3.2994,24.7713-.0168,7.719,2.3384,15.2505,6.7246,20.4228s13.2405,7.438,16.8101,4.4784l-20.2353-49.6725Z",
    style: {
      fill: "#C53F3F"
    }
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 78.9811,
    y: 411.9132,
    width: 43.96442,
    height: 8.1479,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.82524 449.088 88.5253 449.088 83.5643 418.1939 119.74441 418.1939 115.82524 449.088",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.8883 420.2124 119.48833 420.2124 119.04466 423.7099 84.45 423.7099 83.8883 420.2124",
    style: {
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Speech_Bubble_2--inject-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M635.17519,235.8293c11.1066-6.3508,25.2586-2.4956,31.6093,8.611,6.3508,11.1066,2.4956,25.2587-8.6111,31.6095-8.57439,4.9028-18.9495,3.7017-26.1635-2.2017l-6.8731,1.0814,1.6346-7.1675c-.066-.1109-.143-.211-.20739-.3236-6.35091-11.1063-2.49531-25.2584,8.61119-31.6091Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.60645,244.7583c-.03125,0-.06152-.00586-.0918-.01758-.12891-.05078-.19141-.19629-.14062-.32471,2.79883-7.05029,9.4209-12.53271,16.87012-13.96729,.13281-.02686,.2666,.06299,.29199,.19824,.02637,.13574-.0625,.2666-.19824,.29297-7.28516,1.40283-13.76172,6.76514-16.49902,13.66064-.03906,.09814-.13281,.15771-.23242,.15771Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.6123,251.33301h-.00977c-.1377-.00586-.24512-.12207-.24023-.25977,.04688-1.17773,.34375-2.35986,.8584-3.41895,.05957-.125,.21094-.17578,.33398-.11572,.12402,.06055,.17578,.20996,.11523,.33447-.48438,.99707-.76367,2.11084-.80762,3.21973-.00586,.13477-.11621,.24023-.25,.24023Z",
    style: {
      fill: "#C53F3F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "643.95849 264.6947 634.18009 255.7713 637.29409 252.3591 643.85119 258.3428 654.74619 247.7038 657.97339 251.0086 643.95849 264.6947",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Speech_Bubble_1--inject-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M396.57689,87.908c11.6684-6.7801,26.6238-2.8178,33.404,8.8506s2.8178,26.624-8.8507,33.4042c-9.008,5.2343-19.9603,4.0437-27.6128-2.1301l-7.2417,1.1912,1.6715-7.5722c-.0704-.1165-.1524-.2216-.2211-.3398-6.7803-11.6681-2.8174-26.6236,8.8508-33.4039Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.02344,91.38379c-.07617,0-.15137-.03467-.2002-.10059-4.67871-6.27979-12.75977-9.97314-20.55762-9.4082-.1377,.00879-.25781-.09424-.2666-.23145-.01074-.1377,.09375-.25732,.23145-.26758,7.9707-.57178,16.2168,3.19629,20.99316,9.6084,.08301,.11084,.05957,.26758-.05078,.3501-.04492,.0332-.09766,.04932-.14941,.04932Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.08887,82.99805c-.09668,0-.18848-.05615-.22949-.1499-.05469-.12695,.00293-.27393,.12988-.3291,1.12988-.49268,2.37988-.75293,3.61621-.75293,.12207-.00732,.26758,.10498,.26758,.25049,0,.1377-.1123,.24951-.25,.24951,0-.00049-.01074,.00049-.01758,0-1.16797,0-2.34863,.24561-3.41699,.71094-.03223,.01416-.06641,.021-.09961,.021Z",
    style: {
      fill: "#C53F3F"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 396.62369,
    y: 105.5232,
    width: 22.8254,
    height: 5.7063,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "417.33869 114.3353 417.33869 102.8061 422.96059 108.5707 417.33869 114.3353",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character_3--inject-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M546.07829,233.0466s-.60729,10.4731-5.7224,28.8278c-3.2085,11.3421-7.1027,22.4791-11.6606,33.3492-2.5509,6.1408-5.4795,12.6595-8.8401,19.5156-1.5116,3.1176-3.1311,6.2891-4.8316,9.5418-1.957,55.5504-33.1332,112.0185-33.1332,112.0185-1.7275,.8908-7.7603-.0809-7.7198-1.8354,4.6157-7.3285,13.6986-78.5075,19.556-112.275,.3643-4.5888,.8908-9.4473,1.5385-14.5894,1.714-13.6312,4.2514-28.4501,6.7482-41.4874,3.8733-20.5413,7.5578-36.6422,7.5578-36.6422l10.2706,.9987,26.2366,2.5778Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.553,448.2842h-1.75461l-.4993-2.2134-5.9383,2.6993h-15.0484s-2.3888-2.4024,4.7642-4.3053c.3487-.0995,.68741-.2305,1.0122-.3914,3.8194-1.795,9.245-7.8414,9.245-7.8414h8.2461c.2549,.3829,.4806,.7845,.6749,1.2012,.90421,1.7816,2.4564,5.6415-.70179,10.851Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.25479,437.4062h0c-1.0797-1.2146-6.0329,4.1164-9.6633,5.9383-3.2391,1.6062-6.8831,2.3215-8.5026,.6884,3.8194-1.795,10.6214-10.1949,10.6214-10.1949l5.8305,.5856s1.3361,2.1999,1.714,2.9826Z",
    style: {
      fill: "#eec1bb"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M558.33289,309.9479h0c-.8277,5.9744-1.894,12.3671-3.1986,19.1783,11.1345,37.155-11.7687,109.6702-11.7687,109.6702-3.8733,.7693-7.3015,.2699-9.0424-1.0393,4.3187-21.8503,1.2146-78.6559-2.146-112.5988-.2969-3.0772-.6747-6.4648-1.0796-10.0817-.6883-6.1273-1.5115-12.8754-2.3888-19.853-1.4846-11.6742-3.1447-23.9557-4.64279-34.8471-1.83541-13.1589-3.428-24.2933-4.25121-29.8942-.3375-2.4563-.5399-3.8464-.5399-3.8464l32.148,3.482s8.1787,9.1639,9.4474,37.7894c.4191,14.0613-.4301,28.1318-2.5374,42.0406Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.162,448.2842h-1.79511l-.4994-2.2134-5.9248,2.6993h-15.03469s-2.38891-2.4024,4.77749-4.3053c.3487-.0995,.68751-.2305,1.0122-.3914,3.8061-1.795,9.245-7.8414,9.245-7.8414h8.2462c.2485,.3868,.4737,.7878,.6748,1.2012,.9042,1.7816,2.4159,5.6415-.70169,10.851Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.86369,437.4062h0c-1.0932-1.2146-6.0463,4.1164-9.6769,5.9383-3.239,1.6062-6.8829,2.3215-8.4891,.6884,3.806-1.795,9.8118-9.6093,9.8118-9.6093h6.6266s1.3362,2.1999,1.7276,2.9826Z",
    style: {
      fill: "#eec1bb"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M566.77489,152.3223c-1.6508-1.4258-4.318-.8792-6.5883-1.1461-3.4462-.4053-6.223-2.8946-7.7064-5.7194-1.4834-2.8246-1.9146-5.9857-2.443-9.0729-.5283-3.0872-1.2114-6.2492-3.1035-8.8693s-6.4491-5.8679-9.7599-3.8814l-4.4341,6.8715c2.66131,8.0504,4.82531,16.2336,6.4784,24.4992,.7383,3.6911,1.4717,7.595,4.1513,10.4699,2.62461,2.8159,6.78,4.189,10.8567,4.4522,2.0671,.1334,4.2051,.0011,6.0937-.7658,1.8886-.7668,3.4974-2.2478,3.9159-4.072s-.5866-3.9303-2.5081-4.6281c1.8548-.7832,3.7845-1.6196,5.0205-3.0887,1.23591-1.4692,1.5043-3.7728,.0268-5.0491Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M503.26349,118.126c-5.0684,4.9038-5.70849,10.7409-4.9034,14.7364,1.7017,5.2832,4.2775,8.7734,6.6973,13.7686l8.5844-34.2992c-3.2332,1.2766-4.86779,.8631-10.3783,5.7942Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.55029,112.1313c9.8945,.2005,19.8274,8.4738,20.6048,16.5014,.7775,8.0276-7.1176,18.3862-8.5993,19.0219l-4.68579,1.7228s5.16859-11.9517,3.02359-15.145-3.7005-3.2282-3.7005-3.2282l-6.6428-18.8729Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.14859,114.0344c5.1467-3.6397,11.2272-1.5589,14.8348-.0004,4.0644,2.3458,6.9317,6.3174,7.8788,10.9137,.7862,4.3153,1.739,9.546-.4666,12.2717-1.2283,1.5696-3.0598,2.5505-5.047,2.7028l-24.9289-15.8059c1.6772-3.9631,4.33731-7.4331,7.7289-10.0819Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M520.20439,172.482c1.9492,1.3941,3.3448,.5559,5.3714-.7387,12.17821-7.0605,7.175-12.6505,7.175-12.6505-3.00079-2.4504-3.7412-5.9005-3.8035-11.3539-.0105-.1574-.0321-.3139-.0647-.4682-.1373-.7043-.4889-1.3487-1.0068-1.8452-1.379-1.3944-3.6275-1.4069-5.0221-.0278l-.0038,.0039-5.5302,2.7299h0c-.0013,.083-.0029,.1661-.0044,.2595,.511,2.8959,1.0025,5.1268,1.3044,6.8972-.0038,.2181,.0755,.4376,.1031,.6458h0c-.00379,.2179,.0547,.4474,.0926,.6558,.3008,2.4457-3.1461,6.7453-4.6611,7.8929-.9062,.7633-.5574,3.3063,6.0501,7.9993Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.69989,126.7739c1.5936,10.0178,2.4875,14.208-1.2654,20.489-5.6556,9.4363-18.0036,9.4426-22.5383,.1533-4.0104-8.3769-5.9869-23.3135,2.5849-29.6051,8.57191-6.2916,19.6151-1.0654,21.2188,8.9628Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.67419,134.5144c-.6167,2.3376-2.16519,4.1199-3.7823,5.0252-2.4325,1.3613-4.9168-2.4695-4.7344-5.3255,.1646-2.571,2.3067-4.8238,4.9856-4.9985,2.6392-.1722,4.2365,2.6261,3.5311,5.2988Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.0166,135.7334c-.11719,0-.22168-.08203-.24512-.20068-.2041-1.02051,.00879-2.10303,.58398-2.96924,.5752-.86719,1.48926-1.4834,2.50879-1.69092,.13184-.02881,.2666,.06006,.29492,.19531,.02734,.13525-.05957,.26709-.19531,.29492-.89062,.18115-1.68945,.71973-2.19238,1.47705-.50195,.75732-.68848,1.70264-.50977,2.59424,.02734,.13574-.06055,.26758-.19629,.29443-.0166,.00342-.0332,.00488-.04883,.00488Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M517.48429,133.4368c.2342,1.0564-.0988,2.0661-.7438,2.2549-.6447,.189-1.3569-.5138-1.591-1.5702-.2341-1.056,.0987-2.0658,.74351-2.2548,.64459-.1891,1.357,.5138,1.59129,1.5701Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.75319,136.0414c.2247,1.0241-.11419,2.0073-.7568,2.196-.6428,.1884-1.346-.4888-1.5711-1.5132-.2247-1.0239,.1142-2.0072,.7571-2.1957,.64261-.1889,1.346,.4888,1.5708,1.5129Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.55719,129.246c-.1219,.0481-.25919,.046-.3811-.0174-1.8998-.995-3.4764-.0378-3.4944-.0267-.2336,.1424-.5288,.0686-.657-.1744-.1274-.2427-.0398-.5577,.1956-.705,.0824-.0505,2.0603-1.2541,4.418-.0185,.2349,.1231,.3221,.4302,.1949,.6856-.0618,.1228-.162,.2115-.276,.2564Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.14279,131.9795c-.1084-.0064-.2111-.0579-.284-.1541-.1503-.1991-.1174-.5125,.0731-.6996,1.9104-1.8773,3.8417-1.3668,3.9237-1.3432,.2302,.0642,.3538,.331,.2759,.5968-.0772,.2651-.3264,.4281-.5563,.3652-.0753-.0211-1.5796-.3919-3.0984,1.1013-.0984,.0964-.2195,.1407-.334,.1336Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.26779,134.8442s-.5425,4.1085-1.6595,6.8804c-.19529,.4844,.1521,1.0204,.6723,1.0664,1.3388,.1182,2.6539-.6733,2.6539-.6733l-1.6667-7.2735Z",
    style: {
      fill: "#d4827d"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M516.27579,131.8091l-2.4075,.0785s1.69471,1.3522,2.4075-.0785Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.42139,134.4886l-2.4076,.0785s1.6944,1.352,2.4076-.0785Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M526.68819,129.8351s-6.8871-5.4737-8.0783-11.0122c0,0-21.2175-.8095-16.1304,16.4492,0,0-7.1807-14.4184,9.0281-19.9382s23.6109,15.6137,17.4406,24.574c-.0436-.0732,2.0095-6.6352-2.26-10.0728Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.32879,118.8931c-1.8096,2.5039-2.7746,5.5191-2.7551,8.6083,.3954,2.1708,3.6365,3.2016,3.6365,3.2016l2.7469-5.3913,.7575,4.1584c5.7925-1.7254,8.638-5.4859,9.8357-10.3845l-4.3674-5.2843s-8.2023,3.0345-9.8541,5.0918Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M516.40137,144.18701c-.12305,0-.24707-.00977-.36914-.02979-.13574-.02197-.22852-.15039-.20703-.28662,.02246-.13525,.14551-.22998,.28711-.20654,.58398,.09424,1.21484-.10352,1.64062-.51953,.4248-.41504,.63965-1.03906,.55859-1.62842-.01855-.13672,.07715-.2627,.21387-.28125,.15039-.02539,.2627,.07764,.28223,.21387,.10059,.74316-.16895,1.52979-.70508,2.05322-.44824,.4375-1.0752,.68506-1.70117,.68506Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M508.95029,226.6359h42.6885l1.1607,5.5064s15.6826,21.7019,7.7333,75.8218c0,0-34.3479,3.9678-66.6982-2.9692,0,0,7.2609-55.6044,14.8458-73.7568l.2699-4.6022Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M549.48279,209.8537l3.0354,22.7009-46.7979-1.8858c-.1235-4.8768,4.2273-17.8195,3.724-21.3579-1.42-4.3717-8.6094-10.9696-10.523-16.2519-2.0411-7.3345,2.1726-27.5031,3.5474-28.1427,1.6659-.7748,3.7426-.705,5.0204-1.2674,4.96691-1.1687,16.2683-5.2052,21.33191-5.8349,.98039-.0918,1.95289-.2687,2.92069-.3808,0,0,19.1471-.9216,19.9945,6.8688,.0836,.433-4.5639,20.8689-2.2534,45.5517Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.73179,225.2978c.6264-.0817,6.1829-6.1182,6.1829-6.1182l15.8955,.6016-.7685-5.7477c.4721-.3724-18.5743,.4962-18.5743,.4962l-2.7356,5.9327v4.8354Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.50659,159.2442c.819,.1017,4.1472-1.7827,10.1557,5.9342,6.0084,7.7167,12.74371,37.1357,13.1239,41.4282,.4829,5.4508-3.1496,8.1383-6.77219,8.7364-10.86781,1.7942-30.92711,2.1562-30.92711,2.1562v-9.2403l20.0144-4.5313s-11.358-27.3423-9.56529-34.3866c1.79259-7.0442,3.97059-10.0968,3.97059-10.0968Z",
    style: {
      fill: "#C53F3F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M535.50539,157.4068c-1.4455,7.8553-7.32039,14.0207-15.0553,16.0126-2.7129,.6518-5.7452-.8491-7.8898-2.6264-2.1735-1.814-3.6209-4.3501-4.0767-7.1441,9.4199-3.7134,17.9513-6.8982,27.0218-6.2421Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.10129,203.7276s3.2533-.1843,4.6328,1.5895c0,0-.8308-3.3989-5.0796-2.6849l.4468,1.0954Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M523.62339,263.0191v-103.037h-102.8916v41.168c1.8648,.7085,7.9584,1.1751,9.811,.4848,3.2474-1.21,1.12821-4.9519,4.2635-6.4282,4.6261-2.1782,10.3895,.8917,12.8142,5.3933,1.881,3.4919,2.234,5.3207,2.0613,8.3377,.1727,3.0172-.1803,4.8458-2.0613,8.338-2.4247,4.5015-8.1881,7.5712-12.8142,5.3932-3.13529-1.4762-.5855-5.1251-3.8329-6.3352-1.8526-.6903-8.3768-.3168-10.2416,.3918v46.2936h46.0107c.0549,1.0049-.0598,2.0098-.415,2.963-1.2101,3.2475-4.6619,5.1798-6.1382,8.3152-2.1781,4.6259,.89171,10.3894,5.3934,12.8142,3.492,1.8808,5.3207,2.2339,8.3378,2.0613,3.0171,.1726,4.8459-.1805,8.3378-2.0613,4.5015-2.4248,7.5714-8.1883,5.3933-12.8142-1.4764-3.1354-4.928-5.0677-6.1381-8.3152-.3552-.9532-.47-1.9581-.4149-2.963h42.5248Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M528.73179,263.0191v-103.037h-102.8917v41.168c1.8648,.7085,3.907,.8849,5.7596,.1946,3.2474-1.21,5.1797-4.6617,8.315-6.138,4.6261-2.1782,10.3895,.8917,12.8142,5.3933,1.881,3.4919,2.234,5.3207,2.0613,8.3377,.1727,3.0172-.1803,4.8458-2.0613,8.338-2.4247,4.5015-8.1881,7.5712-12.8142,5.3932-3.1353-1.4762-5.0676-4.928-8.315-6.1381-1.8526-.6903-3.8948-.5139-5.7596,.1947v46.2936h46.0108c.0549,1.0049-.0598,2.0098-.415,2.963-1.2101,3.2475-4.66189,5.1798-6.1383,8.3152-2.178,4.6259,.8918,10.3894,5.3935,12.8142,3.492,1.8808,5.3207,2.2339,8.3378,2.0613,3.01711,.1726,4.8459-.1805,8.3378-2.0613,4.5015-2.4248,7.5714-8.1883,5.39331-12.8142-1.47641-3.1354-4.928-5.0677-6.13811-8.3152-.3552-.9532-.47-1.9581-.41489-2.963h42.52479Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M528.73179,263.0191v-103.037h-102.8917v41.168c1.8648,.7085,3.907,.8849,5.7596,.1946,3.2474-1.21,5.1797-4.6617,8.315-6.138,4.6261-2.1782,10.3895,.8917,12.8142,5.3933,1.881,3.4919,2.234,5.3207,2.0613,8.3377,.1727,3.0172-.1803,4.8458-2.0613,8.338-2.4247,4.5015-8.1881,7.5712-12.8142,5.3932-3.1353-1.4762-5.0676-4.928-8.315-6.1381-1.8526-.6903-3.8948-.5139-5.7596,.1947v46.2936h46.0108c.0549,1.0049-.0598,2.0098-.415,2.963-1.2101,3.2475-4.66189,5.1798-6.1383,8.3152-2.178,4.6259,.8918,10.3894,5.3935,12.8142,3.492,1.8808,5.3207,2.2339,8.3378,2.0613,3.01711,.1726,4.8459-.1805,8.3378-2.0613,4.5015-2.4248,7.5714-8.1883,5.39331-12.8142-1.47641-3.1354-4.928-5.0677-6.13811-8.3152-.3552-.9532-.47-1.9581-.41489-2.963h42.52479Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M528.73179,210.0653s-6.9065,1.7262-7.6631,3.351c-.7564,1.625,1.7987,1.5007,1.7987,1.5007,0,0-2.803,.3097-2.83239,1.5175-.03541,1.4497,2.64109,1.3073,2.64109,1.3073,0,0-2.2784,.3466-2.2324,1.4227,.0476,1.1163,3.0799,1.1702,3.0799,1.1702,0,0-1.5584,.5475-1.1031,1.2777,.4553,.73,6.8886,.9691,8.7831-.235,1.8943-1.204,1.9019-9.4712,1.5326-11.2752-.3695-1.8041-1.7384-2.7769-4.0044-5.5165v5.4796h0Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.87369,215.0523l.0116-.0013,4.86071-.7738c.06519-.0106,.11019-.0792,.10009-.153-.0102-.0743-.0738-.1268-.1364-.1158l-4.86069,.7739c-.06521,.0107-.11,.0792-.10011,.1531,.0096,.0701,.0642,.1199,.1248,.1169Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.822,217.8704l.003-.0001,4.72789-.3721c.0658-.0052,.1147-.0698,.1094-.1443-.0055-.075-.0529-.1195-.129-.1261l-4.728,.3719c-.0658,.0054-.1147,.0699-.1094,.1443,.0054,.074,.0615,.1296,.12611,.1264Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.69169,220.4623l3.5211-.1759c.0659-.0034,.1163-.0668,.1125-.1414-.0036-.0746-.0601-.1329-.126-.1297l-3.5211,.176c-.0659,.0033-.11619,.0667-.1125,.1414,.0036,.0747,.0601,.1328,.126,.1296Z",
    style: {
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M449.75459,207.338s7.3966,2.0675,8.1532,3.6923c.7566,1.6251-1.7986,1.5007-1.7986,1.5007,0,0,2.8031,.3097,2.8325,1.5175,.0352,1.4498-2.6412,1.3074-2.6412,1.3074,0,0,2.2784,.3465,2.2324,1.4226-.0477,1.1163-3.0798,1.1704-3.0798,1.1704,0,0,1.5582,.5474,1.10291,1.2777-.45531,.7299-6.88851,.9689-8.783-.2352-1.89441-1.204-1.902-9.4712-1.53251-11.2752,.3693-1.8041,.5197-1.5062,2.7857-4.2456l.4126,1.5337c.11221,.4169,.1873,.843,.2244,1.2732l.0914,1.0605Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.10279,212.6663l-.0116-.0013-4.8607-.7738c-.0651-.0106-.1101-.0792-.1-.153,.0103-.0741,.0737-.1268,.1363-.1157l4.8607,.7738c.0652,.0107,.1102,.0792,.1002,.1531-.0096,.0701-.0642,.1199-.1249,.1169Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.15469,215.4846l-.0031-.0003-4.7278-.3719c-.0659-.0054-.11479-.0699-.1094-.1444,.0053-.075,.0527-.1196,.1288-.1262l4.7281,.3719c.0659,.0054,.1146,.07,.1094,.1445-.0055,.0738-.0615,.1294-.126,.1264Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.28479,218.0763l-3.5209-.1759c-.0661-.0032-.1165-.0668-.1127-.1414,.0037-.0745,.0601-.1328,.1261-.1297l3.5211,.176c.066,.0033,.1162,.0669,.11261,.1416-.00381,.0745-.06021,.1327-.12621,.1294Z",
    style: {
      opacity: 0.2
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character_2--inject-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "298.1806 436.7576 308.3925 437.7575 315.9397 411.9026 300.4044 410.2116 298.1806 436.7576",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M309.8716,433.2482h-3.6461c-.8249,0-1.5881,.4173-2.0754,1.083-2.1026,2.8715-3.6826,1.786-5.9695-.9134-1.4539-.1696-1.8453,1.4989-1.9639,1.9473l-2.7256,9.9144c-.2367,.8279,.2425,1.691,1.0704,1.9278,.1472,.0421,.2999,.0623,.4531,.0597h28.8862c4.59421,0,5.5463-4.6298,3.6539-5.0583-8.5098-1.8805-14.5358-4.3846-17.1662-6.8603-.4877-.4335,.0133-.7576-.5169-2.1002Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.7833,436.0673c.3835-.2759,.6132-.7177,.6187-1.1902,.0323-.2535-.0831-.5033-.2974-.6427-1.1427-.8094-5.7011,1.3212-6.213,1.5711-.0568,.0204-.1016,.0652-.122,.122-.0378,.1052,.0168,.2211,.122,.2589,1.1203,.2651,2.2651,.4126,3.416,.4403,.8637,.0822,1.7311-.1138,2.4757-.5594Zm.0356-1.4878c.0928,.0575,.1404,.1666,.1191,.2737-.0192,.3412-.184,.6577-.4523,.8689-1.0355,.7737-3.5351,.4405-4.8799,.1904,1.8924-.833,4.5824-1.7734,5.2131-1.333Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.0465,436.234c1.3686-.5714,4.2371-2.8209,4.0824-4.011-.0238-.25-.2024-.5475-.8213-.6309-2.4994-.2856-3.5707,4.2015-3.5707,4.3919-.0247,.077-.0012,.1611,.0596,.2142,.0465,.014,.0963,.014,.1427,0l.1073,.0358Zm3.1778-4.273c.4642,.0477,.4642,.2143,.4642,.2739,.1309,.726-1.9519,2.5945-3.4398,3.3801,.3094-1.0474,1.226-3.6658,2.8089-3.6658l.1667,.0118Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.30664,438.30664c-.0459,0-.0918-.0127-.1333-.03809-.1167-.07422-.15186-.22852-.07812-.34473,.71631-1.13867,1.93994-1.92773,3.27393-2.11035,.13281-.01465,.2627,.07715,.28125,.21387,.01904,.13672-.07666,.2627-.21387,.28223-1.18848,.16211-2.27979,.86523-2.91846,1.87988-.04736,.07617-.12842,.11719-.21143,.11719Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.57227,440.01172c-.0459,0-.0918-.0127-.1333-.03809-.1167-.07422-.15186-.22852-.07812-.34473,.71729-1.13965,1.94092-1.92773,3.27393-2.10938,.13281-.0166,.26221,.07715,.28125,.21387,.01855,.1377-.07715,.26367-.21387,.28223-1.18799,.16113-2.27881,.86426-2.91846,1.87891-.04736,.07617-.12842,.11719-.21143,.11719Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.3916,441.44629c-.0459,0-.0918-.0127-.1333-.03809-.1167-.07422-.15186-.22852-.07812-.34473,.71631-1.13867,1.93994-1.92773,3.27393-2.11035,.1333-.01367,.2627,.07715,.28125,.21387,.01904,.13672-.07666,.2627-.21387,.28223-1.18848,.16211-2.27979,.86523-2.91846,1.87988-.04736,.07617-.12842,.11719-.21143,.11719Z",
    style: {
      fill: "#C53F3F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "311.9508 425.5673 311.0253 428.7382 299.007 426.8921 299.2247 424.2926 311.9508 425.5673",
    style: {
      opacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "357.62509 436.7576 367.837 437.7575 375.38419 411.9026 359.84879 410.2116 357.62509 436.7576",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M369.31609,433.2482h-3.6459c-.8251,0-1.58819,.4173-2.0757,1.083-2.10249,2.8715-3.6824,1.786-5.9694-.9134-1.4538-.1696-1.84509,1.4989-1.9638,1.9473l-2.7256,9.9144c-.23669,.8279,.2424,1.691,1.07031,1.9278,.14739,.0421,.30009,.0623,.45309,.0597h28.8863c4.5942,0,5.5464-4.6298,3.654-5.0583-8.51-1.8805-14.5359-4.3846-17.1662-6.8603-.4878-.4335,.0131-.7576-.5171-2.1002Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.22779,436.0673c.3836-.2759,.6133-.7177,.6189-1.1902,.03231-.2535-.0834-.5033-.2976-.6427-1.1425-.8094-5.70109,1.3212-6.2128,1.5711-.0569,.0204-.1017,.0652-.1222,.122-.0376,.1052,.017,.2211,.1222,.2589,1.1202,.2651,2.265,.4126,3.4159,.4403,.8637,.0822,1.7311-.1138,2.4756-.5594Zm.0357-1.4878c.0929,.0575,.1404,.1666,.1191,.2737-.0191,.3412-.1839,.6577-.4523,.8689-1.0356,.7737-3.535,.4405-4.8799,.1904,1.8924-.833,4.5823-1.7734,5.2131-1.333Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.491,436.234c1.36879-.5714,4.23719-2.8209,4.08239-4.011-.0238-.25-.2023-.5475-.8212-.6309-2.4995-.2856-3.5707,4.2015-3.5707,4.3919-.0246,.077-.0013,.1611,.05951,.2142,.04669,.014,.09619,.014,.14289,0l.10711,.0358Zm3.17779-4.273c.4643,.0477,.4643,.2143,.4643,.2739,.1308,.726-1.952,2.5945-3.4398,3.3801,.3095-1.0474,1.226-3.6658,2.8089-3.6658l.1666,.0118Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.75098,438.30664c-.0459,0-.0918-.0127-.1333-.03809-.1167-.07422-.15186-.22852-.07812-.34473,.71631-1.13867,1.93994-1.92773,3.27393-2.11035,.13281-.01465,.26221,.07715,.28125,.21387s-.07666,.2627-.21387,.28223c-1.18848,.16211-2.27979,.86523-2.91846,1.87988-.04736,.07617-.12842,.11719-.21143,.11719Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.01709,440.01172c-.0459,0-.0918-.0127-.1333-.03809-.1167-.07422-.15186-.22852-.07812-.34473,.71729-1.13965,1.94092-1.92773,3.27393-2.10938,.13184-.0166,.26221,.07715,.28125,.21387,.01855,.1377-.07715,.26367-.21387,.28223-1.18799,.16113-2.27881,.86426-2.91846,1.87891-.04736,.07617-.12842,.11719-.21143,.11719Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.83594,441.44629c-.0459,0-.0918-.0127-.1333-.03809-.1167-.07422-.15186-.22852-.07812-.34473,.7168-1.13867,1.94092-1.92773,3.27393-2.11035,.14941-.00879,.26367,.07812,.28223,.21387,.01855,.13672-.07715,.2627-.21387,.28223-1.18896,.16211-2.28027,.86523-2.91943,1.87988-.04736,.07617-.12842,.11719-.21143,.11719Z",
    style: {
      fill: "#C53F3F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "371.39529 425.5673 370.46979 428.7382 358.45149 426.8921 358.66929 424.2926 371.39529 425.5673",
    style: {
      opacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M379.45209,241.9244s8.464,37.3769,12.4978,69.9333c1.2295,9.9225,1.4637,23.192-.7084,32.9609l-16.3138,81.1026-20.5288-2.0562c3.2262-34.9781,7.7219-78.1186,9.0097-96.4735-4.51559-21.5089-14.1377-47.5458-23.5979-73.4392l39.6414-12.0279Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M379.45209,241.9244s8.464,37.3769,12.4978,69.9333c1.2295,9.9225,1.4637,23.192-.7084,32.9609l-16.3138,81.1026-20.5288-2.0562c3.2262-34.9781,7.7219-78.1186,9.0097-96.4735-4.51559-21.5089-14.1377-47.5458-23.5979-73.4392l39.6414-12.0279Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M311.9963,333.9228c.4643-2.0228,1.2059-6.1318,2.1162-11.5508-.0275-.0063-.0581-.0126-.085-.0189,.6672-7.1666,1.9012-40.4078,4.1683-61.61,1.7424-13.5052,5.1943-22.6443,8.6695-27.1194,.1792-.2296,.3433-.4385,.4926-.6249,.5772-.7207,.9278-1.1174,.9278-1.1174,.6608,.1654,1.3174,.3191,1.9709,.4622,.2446,.0539,.4877,.1061,.7295,.1569,24.5385,5.1306,46.1324-1.3191,46.1324-1.3191,2.2586,5.5785,3.9462,17.4738,5.594,29.8092-2.5667,2.8168-13.8308,6.4712-26.75349,8.893l-3.685,16.6661c-1.93911,10.3331-4.42871,20.4679-6.54361,29.5941l-2.2098,9.9946c-.1344,.6555-.266,1.3057-.3905,1.9441-1.1213,5.7457-27.8022,98.3247-27.8022,98.3247l-17.3826-1.0182s7.7644-64.0748,14.051-91.4662Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.9963,333.9228c.4643-2.0228,1.2059-6.1318,2.1162-11.5508-.0275-.0063-.0581-.0126-.085-.0189,.6672-7.1666,1.9012-40.4078,4.1683-61.61,1.7424-13.5052,5.1943-22.6443,8.6695-27.1194,.1792-.2296,.3433-.4385,.4926-.6249,.5772-.7207,.9278-1.1174,.9278-1.1174,.6608,.1654,1.3174,.3191,1.9709,.4622,.2446,.0539,.4877,.1061,.7295,.1569,24.5385,5.1306,46.1324-1.3191,46.1324-1.3191,2.2586,5.5785,3.9462,17.4738,5.594,29.8092-2.5667,2.8168-13.8308,6.4712-26.75349,8.893l-3.685,16.6661c-1.93911,10.3331-4.42871,20.4679-6.54361,29.5941l-2.2098,9.9946c-.1344,.6555-.266,1.3057-.3905,1.9441-1.1213,5.7457-27.8022,98.3247-27.8022,98.3247l-17.3826-1.0182s7.7644-64.0748,14.051-91.4662Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M352.03659,288.0898c-.0678,.3402,7.9609-28.8422,7.9609-28.8422,0,0,6.7592,26.0537-3.5256,42.3501l-4.4353-13.5079Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M334.76219,156.4277s4.0825,3.1391,9.339,7.6687c1.0949,.9437,2.3005,1.7598,3.5771,2.4379,3.4445,1.8295,6.5843,2.8762,7.4345,1.2155,.189-.3651,.3345-.7606,.44221-1.1753,.72189-2.7808,.42579-6.6901-1.822-8.4792-2.53441-2.0173-3.75641-3.7432-3.29941-6.4738,.2398-1.5483,.8001-3.1463,1.4549-4.6986l-1.9942-2.3317-10.4309-10.5272c.2608,7.0294,.7931,18.548-4.7012,22.3637Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.34879,152.2211c-2.8689-1.7031-6.0164-4.6569-5.6391-8.0318,.1682-1.421,.4746-2.7676,.8151-3.6307l5.8269,7.7147c-.4783,1.2435-.653,2.0656-1.0029,3.9478Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.51039,122.7704c.9818,10.7175,1.1711,15.2624,6.7017,20.8822,8.319,8.4529,21.1174,5.6095,23.3207-5.0138,1.98321-9.5616,.0444-25.4816-10.4771-29.986-10.366-4.4375-20.5269,3.4-19.5453,14.1176Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.85989,126.1497c.0558,1.0034,.6724,1.8287,1.3773,1.8434,.7047,.0148,1.2307-.7864,1.175-1.7898-.0557-1.0032-.6723-1.8286-1.377-1.8435-.7047-.0148-1.2308,.7865-1.1753,1.7899Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.96659,125.9979c.0563,.9721,.6716,1.7724,1.3742,1.7873,.7027,.0147,1.2268-.7613,1.1705-1.7337-.0564-.972-.6715-1.7724-1.37429-1.7872-.70261-.0149-1.22651,.7612-1.17041,1.7336Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.15569,122.3098c.1365,.0152,.2752-.0245,.3811-.1223,1.6511-1.5287,3.5101-.992,3.5317-.9857,.27551,.0802,.5543-.0757,.6174-.3569,.0624-.2807-.1127-.5758-.3916-.6602-.09729-.0287-2.4304-.7049-4.47929,1.1932-.204,.1891-.20811,.5241-.00931,.7478,.09631,.1074,.22231,.1698,.35,.1841Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.39589,121.7762c.1266,.0309,.2614,.0148,.3757-.0566,.2362-.1474,.29741-.4723,.1377-.7252-1.6045-2.5367-3.9901-2.6911-4.0921-2.6956-.2854-.015-.5123,.2094-.5069,.5021,.005,.292,.2402,.5408,.52471,.5572,.09359,.0047,1.94339,.1519,3.21869,2.1692,.0827,.1304,.208,.2165,.3422,.2489Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.07659,129.4942s3.3069-4.9986,1.9445-14.733c-.2285-1.6319,.80391-3.177,2.4217-3.4912,4.6236-.8981,10.8057-6.7306,18.3484,4.8536,0,0-3.5971-13.8765-24.6567-8.2863-18.7418,4.9749-5.9101,20.8597-3.9773,22.4935,1.9329,1.634,5.9194-.8366,5.9194-.8366Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.26789,131.5051c1.2657,2.1981,3.3229,3.5783,5.209,4.0514,2.8368,.7114,4.3017-3.8497,3.3335-6.6919-.8719-2.5584-3.65939-4.2521-6.4203-3.6942-2.7199,.5497-3.5697,3.8216-2.1222,6.3347Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M358.26479,136.4679c-.8725,1.3431-1.9214,3.9454-1.9214,3.9454-.253-.0525-.5059-.1049-.7553-.1706-3.4119-.7985-4.7312-2.2964-5.1587-3.7145-.2309-.7767-.18539-1.5367-.0695-2.1378,.127-.697,.37611-1.1649,.37611-1.1649,1.55609,1.5039,4.67969,2.4933,6.37,2.952,.70569,.1996,1.15879,.2904,1.15879,.2904Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.106,136.1775l-.59651,1.1486c-3.212-.7601-5.3713-1.7261-6.1496-2.9357,.127-.697,.37611-1.1649,.37611-1.1649,1.55609,1.5039,4.67969,2.4933,6.37,2.952Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.58809,140.2427c-3.4119-.7985-4.7312-2.2964-5.1587-3.7145,1.1523,.317,2.5063,.8273,3.6131,1.6376,.8487,.6161,1.2972,1.366,1.5456,2.0769Z",
    style: {
      fill: "#dc5753"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M358.08619,125.7049s1.6767,4.0117,3.5682,6.5126c.33061,.4371,.126,1.0751-.3882,1.2643-1.3234,.4872-2.8723,.0463-2.8723,.0463l-.3077-7.8232Z",
    style: {
      fill: "#d4827d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.82019,124.3356l2.4599-.5811s-1.3452,1.8343-2.4599,.5811Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.88409,124.2896l2.4597-.5811s-1.3451,1.8343-2.4597,.5811Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.66649,120.6572s6.4907-7.6787,2.16-14.0084c-1.6274-2.3787-4.6157-2.7333-7.2529-3.8954-6.0852-2.681-11.0172-3.2226-18.7834,4.3887-8.0798,7.9188-9.5416,10.5855-.6294,20.3419,0,0-.9619-1.2759,2.3329-4.1784,3.2946-2.9026,6.9312-5.485,5.1656-8.2998,0,0,2.7392,1.0565,2.9353,3.663l4.8179-1.3157s-.2093-1.8629-1.484-3.7262c0,0,2.4971,1.471,3.3076,3.628l4.1681,.7845s-.612-3.8242-1.7887-5.1969c0,0,3.8183,3.9258,5.051,7.8147Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M339.63525,131.44043c-.12793,0-.2373-.09814-.24854-.22803-.0835-.94824-.52734-1.86865-1.21777-2.5249-.68945-.65576-1.63135-1.05225-2.5835-1.0874-.13818-.00537-.24561-.12109-.24072-.25928,.00537-.1377,.09766-.22852,.25928-.24072,1.07227,.04004,2.13281,.48633,2.90967,1.2251,.77734,.73877,1.27734,1.77539,1.37109,2.84326,.01221,.1377-.08984,.25879-.22705,.271l-.02246,.00098Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M390.59009,220.1253c-.6035-.4648-1.1754-.9789-1.7107-1.5381-.4552-.4769-.7725-1.0921-.6621-1.0921-.024-.0684-.0516-.1353-.0828-.2l-.1932-.4461-.4691-1.1998c-.31719-.8614-.6207-1.7996-.92419-2.7533-.63461-1.892-1.22781-3.8609-1.80731-5.8451-1.1726-3.9839-2.2901-8.0139-3.4214-12.0593l-2.0756-8.4808c-.30069-1.3741-.7665-3.3759-1.3853-5.6605l-.0017-.0067-.0001,.0001c-1.6877-6.2292-4.5081-14.5385-8.19559-17.8424-5.72481-4.38-9.37881,1.0235-11.73541,6.6413-2.2614,5.3916,3.3206,20.1262,3.3206,20.1262l6.8007-.4915c.8598,3.1354,1.7616,6.2536,2.6497,9.4366,1.1588,4.1531,2.53841,8.2293,3.918,12.3055,.7036,2.0457,1.4348,4.0916,2.2349,6.1528,.4691,1.0458,.8967,2.0765,1.3796,3.1685,.2346,.5384,.4967,1.1076,.7864,1.6767l.5104,.9536c.2143,.3982,.45411,.7786,.7174,1.1383,1.0083,1.2975,2.2489,2.3454,3.6421,3.0764,1.0731,.6013,2.2019,1.0707,3.3661,1.3997,2.1201,.6131,4.3092,.8775,6.4979,.7845l1.2278-5.9374c-1.4624-1.0921-3.0765-2.2304-4.3871-3.3071Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.59009,220.1253c-.6035-.4648-1.1754-.9789-1.7107-1.5381-.4552-.4769-.7725-1.0921-.6621-1.0921-.024-.0684-.0516-.1353-.0828-.2l-.1932-.4461-.4691-1.1998c-.31719-.8614-.6207-1.7996-.92419-2.7533-.63461-1.892-1.22781-3.8609-1.80731-5.8451-1.1726-3.9839-2.2901-8.0139-3.4214-12.0593l-2.0756-8.4808c-.30069-1.3741-.7665-3.3759-1.3853-5.6605l-.0017-.0067-.0001,.0001c-1.6877-6.2292-4.5081-14.5385-8.19559-17.8424-5.72481-4.38-9.37881,1.0235-11.73541,6.6413-2.2614,5.3916,3.3206,20.1262,3.3206,20.1262l6.8007-.4915c.8598,3.1354,1.7616,6.2536,2.6497,9.4366,1.1588,4.1531,2.53841,8.2293,3.918,12.3055,.7036,2.0457,1.4348,4.0916,2.2349,6.1528,.4691,1.0458,.8967,2.0765,1.3796,3.1685,.2346,.5384,.4967,1.1076,.7864,1.6767l.5104,.9536c.2143,.3982,.45411,.7786,.7174,1.1383,1.0083,1.2975,2.2489,2.3454,3.6421,3.0764,1.0731,.6013,2.2019,1.0707,3.3661,1.3997,2.1201,.6131,4.3092,.8775,6.4979,.7845l1.2278-5.9374c-1.4624-1.0921-3.0765-2.2304-4.3871-3.3071Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M370.91789,172.572c1.1488,1.9625,1.54311,3.0801,2.263,5.3409,.7198,2.2607,1.5352,14.4721-2.5871,18.0817v-8.4663c.1504-5.1871,.1736-9.7692,.3241-14.9563Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M320.2069,188.0158l-6.3841-21.7684c4.0387-6.0273,24.021-10.6586,24.021-10.6586l10.2413,3.5939,2.9237-2.8742s5.0597,1.1289,9.3918,2.5416c5.7833,1.886,8.9107,3.4031,10.2895,6.6119,0,0,2.4131,7.11,.9621,21.7613-.399,4.0288,.0536,24.9742,1.1783,31.8936l6.8139,21.5676c-24.0545,18.733-57.72539,1.2399-57.72539,1.2399,1.08119-3.3078,4.68429-13.4643,5.17309-16.6969-.353-4.1241,.1383-10.4836-1.6085-17.7051-.3371-1.3939-4.6912-18.1523-5.2767-19.5066Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.2069,188.0158l-6.3841-21.7684c4.0387-6.0273,24.021-10.6586,24.021-10.6586l10.2413,3.5939,2.9237-2.8742s5.0597,1.1289,9.3918,2.5416c5.7833,1.886,8.9107,3.4031,10.2895,6.6119,0,0,2.4131,7.11,.9621,21.7613-.399,4.0288,.0536,24.9742,1.1783,31.8936l6.8139,21.5676c-24.0545,18.733-57.72539,1.2399-57.72539,1.2399,1.08119-3.3078,4.68429-13.4643,5.17309-16.6969-.353-4.1241,.1383-10.4836-1.6085-17.7051-.3371-1.3939-4.6912-18.1523-5.2767-19.5066Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M393.28529,211.459c.7485-9.0588,7.73371-16.3583,16.7509-17.5045l-1.8458,3.0763,3.5223-2.0919-16.1508,20.2579-2.2766-3.7378Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.28529,211.459c.7485-9.0588,7.73371-16.3583,16.7509-17.5045l-1.8458,3.0763,3.5223-2.0919-16.1508,20.2579-2.2766-3.7378Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.98239,194.8313l5.5527-.1693,26.5797,9.0138-24.2263,37.0087-23.8418-5.9529c-1.359-.3764-2.1555-1.7833-1.7789-3.1423,.0561-.2025,.1369-.3973,.2407-.58l9.6291-17.4122c.1916-.3443,.1916-.7632,0-1.1075l-1.3075-2.3227c-.2748-.4758-.2748-1.0622,0-1.5382l6.4604-12.1054c.5473-.9887,1.5636-1.6275,2.6919-1.692Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400.11479 203.6758 415.25059 193.9545 390.36279 230.9324 375.88849 240.6845 400.11479 203.6758",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400.11479 203.6758 415.25059 193.9545 390.36279 230.9324 375.88849 240.6845 400.11479 203.6758",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M397.14309,220.8731s-5.88209-1.5417-7.1749-.533c-1.2926,1.0088,.4767,1.9675,.4767,1.9675,0,0-2.0248-.9109-2.6292,.06-.7254,1.1654,1.1337,2.16,1.1337,2.16,0,0-1.6917-.6633-2.1819,.2316-.5086,.9284,1.4934,2.2304,1.4934,2.2304,0,0-1.3072-.2009-1.3562,.5822-.0488,.7832,4.1385,3.6467,5.9886,3.4528,1.85-.194,5.857-6.9197,6.4834-8.5414,.62631-1.6217,.5617-2.8846-.6265-4.0127l-1.6071,2.4026h0Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.38359,222.4204l.00841,.0039,3.62579,1.3868c.0487,.0183,.112-.0189,.1411-.0831,.029-.0646,.0119-.1338-.0353-.1508l-3.6258-1.3867c-.04879-.0183-.112,.0188-.141,.083-.0276,.0609-.0152,.1242,.0268,.1469Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.98469,224.6928l.0021,.0012,3.3425,1.6586c.0466,.023,.1106-.0092,.143-.0722,.0328-.0633,.0225-.1191-.0252-.1561l-3.3424-1.6589c-.04669-.023-.1106,.0094-.1431,.0722-.0322,.0625-.0217,.131,.0231,.1552Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.31179,227.1632l2.4403,1.3176c.0457,.0248,.1102-.006,.1438-.0684,.0336-.0622,.024-.133-.0216-.1577l-2.44029-1.3178c-.04581-.0246-.11021,.0062-.14391,.0685s-.02409,.1331,.0217,.1578Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "354.78309 157.2301 350.34419 152.9306 348.08509 159.1827 338.22309 151.3226 333.22169 156.8082 345.60829 165.4393 348.08509 159.9581 354.78309 164.9826 354.78309 157.2301",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.78309,157.2301c.3145,.4836,0,7.7525,0,7.7525l-6.698-5.0245-2.4768,5.4812-11.9025-8.2092,12.1829,10.6148,2.1964-6.4446,7.46991,6.4446-.77191-10.6148Z",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.12059,190.9438l-34.1168,32.872v-6.4963s30.71-28.1315,31.0824-28.1721c.3723-.0406,3.0344,1.7964,3.0344,1.7964Z",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.07739 193.5452 325.38189 178.3043 324.64989 195.9946 329.07739 193.5452",
    style: {
      opacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M335.19959,135.2758c0,1.1323,.9179,2.0503,2.0502,2.0503,1.1324,0,2.0503-.918,2.0503-2.0503s-.9179-2.0503-2.0503-2.0503c-1.1323,0-2.0502,.918-2.0502,2.0503Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M313.8228,166.2474s-4.613,4.491-6.1656,19.8123c-1.1143,10.9969-3.9321,34.7109,4.614,37.7561,8.546,3.0451,45.815-32.5865,45.815-32.5865l-6.05-10.3857-27.3863,15.151s2.7923-25.1177-2.0345-27.4135-8.7926-2.3337-8.7926-2.3337Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.8228,166.2474s-4.613,4.491-6.1656,19.8123c-1.1143,10.9969-3.9321,34.7109,4.614,37.7561,8.546,3.0451,45.815-32.5865,45.815-32.5865l-6.05-10.3857-27.3863,15.151s2.7923-25.1177-2.0345-27.4135-8.7926-2.3337-8.7926-2.3337Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M354.37589,180.0731s3.5954-7.1997,5.3016-7.5172c1.7063-.3175,3.08051,.252,3.08051,.252,0,0,11.61909-6.8454,12.39259-5.044,.4185,.9749-2.1617,3.123-7.7005,6.2828,0,0,3.1895,1.174,1.904,3.0432,0,0,2.34791,1.077,1.0952,3.4101,0,0,1.07771,2.061-.2775,3.377-1.3551,1.3159-7.739,4.9492-11.4359,5.4914-3.69689,.5422-5.8526-6.642-5.8526-6.642l1.4926-2.6533Z",
    style: {
      fill: "#eec1bb"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Puzzle_piece--inject-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M393.62719,385.7914c3.1353,1.4762,5.0676,4.928,8.3151,6.138,1.8241,.6798,3.8326,.5207,5.6746-.1605v-46.3278h-44.3406c-.0551-1.0048,.05971-2.0098,.4149-2.9631,1.2102-3.2474,4.662-5.1797,6.1381-8.315,2.178-4.626-.8917-10.3895-5.3932-12.8142-3.49209-1.8809-5.3207-2.234-8.3379-2.0614-3.0171-.1726-4.8458,.1805-8.3378,2.0614-4.5017,2.4247-7.5715,8.1882-5.3933,12.8142,1.4763,3.1353,4.9281,5.0676,6.13791,8.315,.35529,.9533,.47,1.9583,.41509,2.9631h-44.3403v103.0371h103.0371v-41.2021c-1.842-.6812-3.8505-.8403-5.6746-.1606-3.2475,1.21-5.1926,4.635-8.3151,6.138-4.164,2.0044-10.3698-.899-12.81419-5.3932-1.89511-3.4844-2.234-5.3207-2.06141-8.3378-.17259-3.0172,.18041-4.8458,2.06141-8.3379,2.42479-4.5016,8.18819-7.5713,12.81419-5.3932Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.62719,385.7914c3.1353,1.4762,5.0676,4.928,8.3151,6.138,1.8241,.6798,3.8326,.5207,5.6746-.1605v-46.3278h-44.3406c-.0551-1.0048,.05971-2.0098,.4149-2.9631,1.2102-3.2474,4.662-5.1797,6.1381-8.315,2.178-4.626-.8917-10.3895-5.3932-12.8142-3.49209-1.8809-5.3207-2.234-8.3379-2.0614-3.0171-.1726-4.8458,.1805-8.3378,2.0614-4.5017,2.4247-7.5715,8.1882-5.3933,12.8142,1.4763,3.1353,4.9281,5.0676,6.13791,8.315,.35529,.9533,.47,1.9583,.41509,2.9631h-44.3403v103.0371h103.0371v-41.2021c-1.842-.6812-3.8505-.8403-5.6746-.1606-3.2475,1.21-5.1926,4.635-8.3151,6.138-4.164,2.0044-10.3698-.899-12.81419-5.3932-1.89511-3.4844-2.234-5.3207-2.06141-8.3378-.17259-3.0172,.18041-4.8458,2.06141-8.3379,2.42479-4.5016,8.18819-7.5713,12.81419-5.3932Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.67919,385.7914c3.1352,1.4762,5.0676,4.928,8.3151,6.138,1.824,.6798,3.8325,.5207,5.6746-.1605v-46.3278h-44.3407c-.055-1.0048,.0597-2.0098,.415-2.9631,1.2102-3.2474,4.662-5.1797,6.138-8.315,2.1781-4.626-.8916-10.3895-5.3931-12.8142-3.4922-1.8809-5.3207-2.234-8.3379-2.0614-3.0171-.1726-4.8458,.1805-8.3378,2.0614-4.5017,2.4247-7.5715,8.1882-5.3933,12.8142,1.4763,3.1353,4.9281,5.0676,6.13791,8.315,.35519,.9533,.47,1.9583,.41509,2.9631h-44.3404v103.0371h103.0372v-41.2021c-1.8421-.6812-3.8506-.8403-5.6746-.1606-3.2475,1.21-5.1926,4.635-8.3151,6.138-4.164,2.0044-10.3699-.899-12.81419-5.3932-1.89521-3.4844-2.23411-5.3207-2.06141-8.3378-.1727-3.0172,.18041-4.8458,2.06141-8.3379,2.42479-4.5016,8.18809-7.5713,12.81419-5.3932Z",
    style: {
      fill: "#C53F3F"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character_4--inject-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M522.44189,359.5801l35.2202-13.5333,20.33-19.7087c.5643-.6538,6.45991-10.8201,6.45991-10.8201l9.97819,21.3742s-24.8111,24.9321-33.8976,27.8348c-7.3448,2.3463-33.348,8.717-33.348,8.717l-4.7427-13.8639Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.03249,369.2177s4.2456-16.646,13.7376-20.1086c9.4921-3.4625,21.7624,1.9676,21.4108,2.2019-.3515,.2344-10.6297,9.8041-10.9812,9.9213-.2618,.0872-13.3274,4.6929-20.08969,6.9271l-4.07751,1.0583Z",
    style: {
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M480.08989,345.9713c-.05489,1.0049,.0597,2.0097,.4149,2.963,1.2099,3.2475,4.6617,5.1797,6.1381,8.3151,2.178,4.626-.8918,10.3894-5.3933,12.8142-3.492,1.8809-5.3207,2.234-8.3378,2.0614-3.0172,.1726-4.84579-.1805-8.3379-2.0614-4.5016-2.4248-7.5714-8.1882-5.3932-12.8142,1.4761-3.1354,4.9279-5.0676,6.1379-8.3151,.3553-.9533,.47-1.9581,.4151-2.963h-45.92569v46.2937c-1.86511,.7086-3.90721,.8849-5.75961,.1946-3.2476-1.2101-5.1798-4.6619-8.3152-6.1381-4.6259-2.1781-10.3894,.8917-12.81419,5.3933-1.88081,3.492-2.23391,5.3207-2.06131,8.3379-.1726,3.0171,.1805,4.8458,2.06131,8.3378,2.42479,4.5015,8.18829,7.5714,12.81419,5.3932,3.1354-1.4763,5.0676-4.928,8.3152-6.138,1.8524-.6903,3.8945-.514,5.75961,.1946v41.1681l102.68079,.4591v-103.0371l-42.3989-.4591Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M480.08989,345.9713c-.05489,1.0049,.0597,2.0097,.4149,2.963,1.2099,3.2475,4.6617,5.1797,6.1381,8.3151,2.178,4.626-.8918,10.3894-5.3933,12.8142-3.492,1.8809-5.3207,2.234-8.3378,2.0614-3.0172,.1726-4.84579-.1805-8.3379-2.0614-4.5016-2.4248-7.5714-8.1882-5.3932-12.8142,1.4761-3.1354,4.9279-5.0676,6.1379-8.3151,.3553-.9533,.47-1.9581,.4151-2.963h-45.92569v46.2937c-1.86511,.7086-3.90721,.8849-5.75961,.1946-3.2476-1.2101-5.1798-4.6619-8.3152-6.1381-4.6259-2.1781-10.3894,.8917-12.81419,5.3933-1.88081,3.492-2.23391,5.3207-2.06131,8.3379-.1726,3.0171,.1805,4.8458,2.06131,8.3378,2.42479,4.5015,8.18829,7.5714,12.81419,5.3932,3.1354-1.4763,5.0676-4.928,8.3152-6.138,1.8524-.6903,3.8945-.514,5.75961,.1946v41.1681l102.68079,.4591v-103.0371l-42.3989-.4591Z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M484.63479,345.9713c-.0549,1.0049,.0597,2.0097,.415,2.963,1.2099,3.2475,4.6617,5.1797,6.138,8.3151,2.1781,4.626-.8917,10.3894-5.3933,12.8142-3.492,1.8809-5.3207,2.234-8.3378,2.0614-3.0172,.1726-4.84569-.1805-8.3379-2.0614-4.5015-2.4248-7.5713-8.1882-5.3931-12.8142,1.476-3.1354,4.9278-5.0676,6.1379-8.3151,.3552-.9533,.47-1.9581,.4151-2.963h-45.92569v46.2937c-1.86511,.7086-3.90721,.8849-5.75971,.1946-3.2475-1.2101-5.1797-4.6619-8.3151-6.1381-4.6259-2.1781-10.3894,.8917-12.81419,5.3933-1.88091,3.492-2.23391,5.3207-2.06141,8.3379-.1725,3.0171,.1805,4.8458,2.06141,8.3378,2.42479,4.5015,8.18829,7.5714,12.81419,5.3932,3.1354-1.4763,5.0676-4.928,8.3151-6.138,1.8525-.6903,3.8946-.514,5.75971,.1946v41.1681l102.68079,.4591v-103.0371l-42.399-.4591Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M556.96139,415.4273l16.1504-.9769c-2.5835,14.2286-5.2407,23.459-4.11,30.7636l-6.5102,4.3519-6.0279-5.9276s-1.1136-11.6302,.4977-28.211Z",
    style: {
      fill: "#e9b376"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M555.49349,433.654l5.8688,.069c2.8389,4.9172,4.80371,3.7594,7.8135,.2901,1.7041-.1784,2.1393,1.78,2.2719,2.3066l3.0541,11.6423c.2658,.9724-.3069,1.9762-1.2793,2.242-.1731,.0472-.352,.0689-.5311,.0638-5.1826-.0609-7.6347-.0897-14.0851-.1655l-19.7272-.2317c-5.3777-.0631-6.4286-5.4956-4.2075-5.9712,9.9869-2.0842,17.075-4.9326,20.1879-7.7941,.5769-.5007-.0051-.8871,.634-2.4513Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.08887,439.54004c-.08398,0-.16602-.04199-.21289-.11914-.74023-1.20801-2.01855-2.05273-3.4209-2.26074-.13574-.02051-.23047-.14746-.20996-.28418,.02051-.13574,.1377-.23438,.28418-.20996,1.5459,.22949,2.95703,1.16113,3.77246,2.49316,.07227,.11816,.03516,.27148-.08203,.34375-.04102,.02539-.08594,.03711-.13086,.03711Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.41309,441.50488c-.08398,0-.16602-.04199-.21289-.11914-.74121-1.20801-2.02051-2.05273-3.4209-2.26074-.13574-.02051-.23047-.14746-.20996-.28418,.02051-.13574,.1377-.23047,.28418-.20996,1.54395,.22852,2.95508,1.16113,3.77246,2.49316,.07227,.11816,.03516,.27148-.08203,.34375-.04102,.02539-.08594,.03711-.13086,.03711Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.09375,443.14453c-.08398,0-.16602-.04199-.21289-.11914-.74121-1.20801-2.02051-2.05273-3.42188-2.26074-.13574-.02051-.23047-.14746-.20996-.28418s.13574-.23145,.28418-.20996c1.54492,.22949,2.95605,1.16113,3.77344,2.49316,.07227,.11816,.03516,.27148-.08203,.34375-.04102,.02539-.08594,.03711-.13086,.03711Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M573.22249,450.204c-.1731,.0472-.352,.0689-.5312,.0637-5.1825-.0608-7.6346-.0896-14.085-.1654l-19.7274-.2316c-2.90989-.0343-4.543-1.6404-5.0863-3.1828,.8188,.016,40.0167,.7798,40.53541,.6117l.20839,.868c.1392,.9046-.4101,1.7893-1.3139,2.0364Z",
    style: {
      fill: "#fff",
      opacity: 0.7
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M618.81079,372.5939s-44.10779-22.7776-52.6962-23.4268c-8.5884-.6492-16.7961,4.0019-18.4377,21.7853-1.6415,17.7835,1.6416,63.518,1.6416,63.518l23.7927,.4081,2.94881-52.9837s36.84859,26.9172,37.94289,26.6436c1.0944-.2736,15.4779-.9247,15.4779-.9247l-10.67-35.0198Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.81079,372.5939s-44.10779-22.7776-52.6962-23.4268c-8.5884-.6492-16.7961,4.0019-18.4377,21.7853-1.6415,17.7835,1.6416,63.518,1.6416,63.518l23.7927,.4081,2.94881-52.9837s36.84859,26.9172,37.94289,26.6436c1.0944-.2736,15.4779-.9247,15.4779-.9247l-10.67-35.0198Z",
    style: {
      fill: "#fff",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.70819,406.6734s-19.4379,6.8078-19.64519,22.8385c-.20741,16.0306,16.93609,12.9797,16.93609,12.9797l2.7091-35.8182Z",
    style: {
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M635.69419,448.4395l-4.37319-15.8974c15.28529-1.6546,25.49669,2.1092,32.60319-1.2451l6.399,5.3258-4.2265,7.932s-11.26769,3.8286-30.4025,3.8847Z",
    style: {
      fill: "#e9b376"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M656.20989,448.5532l-1.6986-6.0041c4.1576-4.3763,2.385-6.0306-2.0591-8.0537-.6955-1.6835,1.1699-2.7174,1.6669-3.0113l10.9492-6.6229c.9113-.5639,2.1073-.2825,2.6713,.6287,.10041,.1623,.1763,.3381,.225,.5222,1.5,5.3023,2.2096,7.8108,4.0766,14.4101l5.7094,20.1824c1.5565,5.5017-3.6654,8.2105-4.8197,6.0894-5.13489-9.5539-10.1752-15.9219-14.0308-18.2331-.6844-.4372-.9028,.2725-2.6902,.0923Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.43652,450.88086c-.12305,0-.23047-.08984-.24805-.21484-.23047-1.64062,.29395-3.35449,1.40234-4.58496,.0918-.10156,.25098-.11035,.35254-.01855,.10254,.0918,.11133,.25,.01855,.35254-1.01074,1.12207-1.48828,2.68555-1.27734,4.18066,.01855,.13672-.07617,.26367-.21289,.2832-.01172,.00098-.02344,.00195-.03516,.00195Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.24707,453.0166c-.12305,0-.22949-.08984-.24707-.21484-.23242-1.64062,.29102-3.35449,1.40039-4.58496,.0918-.10156,.25-.11035,.35254-.01855s.11133,.25,.01855,.35254c-1.01074,1.12305-1.48828,2.68555-1.27734,4.18066,.01953,.13672-.0752,.26367-.21191,.28223-.01172,.00195-.02344,.00293-.03516,.00293Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.91895,455.90723c-.12305,0-.23047-.08984-.24805-.21484-.23047-1.64062,.29395-3.35449,1.40234-4.58594,.0918-.10254,.25-.11035,.35254-.01855s.11133,.25,.01855,.35254c-1.01074,1.12305-1.48828,2.68652-1.27734,4.18164,.01855,.13672-.07617,.26367-.21289,.2832-.01172,.00098-.02344,.00195-.03516,.00195Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M667.73959,425.4899c.10041,.1623,.1763,.3381,.225,.5223,1.5,5.3022,2.2096,7.8107,4.0766,14.41l5.7095,20.1825c.8421,2.9771-.3031,5.1261-1.7119,6.1449-.2305-.8396-11.26579-41.0332-11.5935-41.5113l.8221-.4741c.8803-.4146,1.9478-.1213,2.4722,.7257Z",
    style: {
      fill: "#fff",
      opacity: 0.7
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M667.15059,381.2771l1.9149,9.6137s4.9089,19.0701-1.9718,28.6483c-6.5736,9.1508-16.27269,10.7827-16.27269,10.7827l1.99379,18.391-1.99379,1.2419s-12.68781,0-38.66021-1.1858c-24.6719-1.1265-45.8797-2.3052-50.2571-9.9658-4.3775-7.6605-5.3884-11.3806,1.7704-20.5194,6.4693-8.2586,55.7261-20.4242,57.43991-20.9166l-.68791-4.197-.7989-2.9724,47.5234-8.9206Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.15059,381.2771l1.9149,9.6137s4.9089,19.0701-1.9718,28.6483c-6.5736,9.1508-16.27269,10.7827-16.27269,10.7827l1.99379,18.391-1.99379,1.2419s-12.68781,0-38.66021-1.1858c-24.6719-1.1265-45.8797-2.3052-50.2571-9.9658-4.3775-7.6605-5.3884-11.3806,1.7704-20.5194,6.4693-8.2586,55.7261-20.4242,57.43991-20.9166l-.68791-4.197-.7989-2.9724,47.5234-8.9206Z",
    style: {
      fill: "#fff",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.821,430.3218c-1.51361,.3954-55.02031-1.3305-55.02031-1.3305,0,0,15.8149,2.7123,27.5101,3.6986,11.6953,.9863,27.51021-2.3681,27.51021-2.3681Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.114,397.3671l30.81069-5.3733s-22.209-.3611-30.81069,5.3733Z",
    style: {
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M542.568,375.5513s-2.57051-3.9566-6.39581-4.7225c-3.8254-.766-6.6761-2.3957-9.5593-2.7685-2.8832-.373-.2674,2.5519,1.4392,3.8263,1.7064,1.2742,3.6277,2.7361,2.4632,3.8628-1.16429,1.127-14.6736,4.5536-16.1101,6.2997-1.4369,1.7462,.9217,1.8754,.9217,1.8754,0,0-3.2586,.9205-3.2457,2.3107,.0035,.3611,.597,1.1954,2.14781,1.0086,3.48869-.4202,10.765-1.6791,10.765-1.6791-.41911,.0637-9.28941,2.2591-10.575,2.7612-1.68031,.6564-2.13791,1.8229-1.72541,2.7845,.5868,1.3689,11.6776-.9781,12.21441-.75,0,0-6.43021,1.1376-7.04491,2.9582s3.4721,1.3253,6.9928,.2041c3.2273-1.0278,9.8278-2.1991,13.00711-3.5624,3.91819-1.6797,6.17129-3.6877,6.25649-7.684,.0849-3.9966-1.55149-6.725-1.55149-6.725Z",
    style: {
      fill: "#e9b376"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "538.34129 375.465 548.20659 371.5189 551.61459 382.1914 540.04529 386.3169 538.34129 375.465",
    style: {
      fill: "#e9b376"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M609.90829,301.6526s-2.67929-6.0514-2.1112-18.031c-.0034-.0118-.6558-.1325-.6593-.1444,.0727-1.6736,.203-3.2355,.352-4.5979,.0016-.0389-.0019-.0508-.0019-.0508l-13.0577,13.1361c1.21681,3.4962,1.5871,10.7261,1.5195,13.8328,0,0-.6682,5.7572,6.4296,4.3039,5.1863-1.062,7.529-8.4487,7.529-8.4487Z",
    style: {
      fill: "#e9b376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.37209,297.0642l8.3436-4.0978c-.1442,2.9341-1.7936,6.7655-7.8674,8.4991,0,0-.12229-3.2159-.4762-4.4013Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M605.82559,271.356c1.2907,9.962,2.2196,15.5544-1.7985,21.5213-6.044,8.9754-18.77909,6.8662-23.0319-2.5371-3.8278-8.4638-5.2957-23.333,3.6242-29.0179,8.7882-5.6008,19.9155,.0718,21.2062,10.0337Z",
    style: {
      fill: "#e9b376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.98939,257.3425c-4.612-5.399-13.2-.6715-16.4642,2.8319-.4879,.5236,8.3449,3.0189,7.8223,2.9348l2.7903,2.3133c.3597-.1558,1.1045,3.2683,1.7339,6.2344,.5782,2.7242,1.8785,5.2324,3.778,7.269,1.5915,1.7063,3.7232,3.7503,6.1172,5.4086,3.1147-2.3383,2.1635-8.3598,2.5616-12.131,.5931-5.6187,.4628-16.1376-8.3391-14.861Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.294,278.8147c-.299,2.6865-1.818,4.974-3.58451,6.3201-2.657,2.0253-4.3709-.9763-4.6897-4.1319-.2869-2.8401-.12679-6.3981,3.0486-7.1834,3.1283-.7736,5.5674,1.9238,5.22561,4.9952Z",
    style: {
      fill: "#e9b376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.28059,276.9118c.1939,1.0075-.1845,1.9219-.8453,2.0424-.6606,.1207-1.3539-.5985-1.5478-1.6061-.1941-1.0076,.1844-1.9219,.845-2.0424,.6608-.1205,1.3538,.5984,1.5481,1.6061Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.43709,279.0109c.1942,1.0075-.1842,1.9218-.8449,2.0424-.6608,.1204-1.3539-.5985-1.5481-1.6062-.194-1.0075,.1844-1.9219,.8452-2.0423s1.3538,.5986,1.5478,1.6061Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.54449,277.8332s-2.2256,5.6202-2.8554,7.8555c1.6462,.9968,3.9494-.0524,3.9494-.0524l-1.094-7.8031Z",
    style: {
      fill: "#d58745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.829,271.6889c-.14021,.0913-.32491,.1072-.48591,.0246-1.9154-.9782-3.46609-.127-3.4817-.1185-.2309,.1302-.5259,.05-.6583-.1794-.13209-.2293-.05109-.5214,.1783-.6515,.0813-.0465,2.0243-1.1137,4.4004,.1006,.2373,.121,.33121,.4094,.2103,.6439-.0393,.0761-.0959,.1365-.16309,.1803Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.55859,288.58594c-.17773,0-.33594-.12598-.36914-.30664-.03711-.2041,.09766-.39941,.30078-.4375,1.33398-.24512,2.39258-1.04395,3.54004-2.66895,.12109-.16992,.35547-.20898,.52246-.09082,.16992,.12012,.20996,.35352,.09082,.52246-.89648,1.27051-2.0752,2.61719-4.0166,2.97559-.02344,.00391-.0459,.00586-.06836,.00586Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M604.59375,280.58984c-.12988,0-.23926-.09961-.24902-.23047-.07129-.91113,.09863-1.8291,.49121-2.65527,.2666-.55859,.75391-1.30273,1.56445-1.67578,.7998-.36523,1.74316-.23633,2.29785,.32031,.09766,.09766,.09766,.25586,0,.35352-.09863,.09863-.25684,.09668-.35352,0-.40332-.4043-1.12988-.49805-1.73535-.21973-.6748,.31055-1.0918,.95312-1.32227,1.43652-.35449,.74707-.50879,1.57715-.44434,2.40137,.01074,.1377-.0918,.25781-.22949,.26855l-.01953,.00098Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M577.25849,275.5978c-.0913-.002-.183-.0302-.2639-.0865-.2185-.1521-.2749-.4519-.1252-.6692,1.5013-2.1821,3.7084-2.1185,3.8075-2.1285,.2648,.0092,.4749,.2311,.4688,.4961-.0061,.2644-.2236,.4712-.4865,.4649-.0919-.0063-1.7927-.0333-2.9977,1.7181-.0941,.137-.248,.2088-.403,.2051Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M601.98939,257.3425s-6.1325-7.5785-16.7399-5.0784c-8.532,2.011-12.9823,8.2526-13.1477,14.2242-.0711,2.5662,.4984,4.4752,1.1711,5.8179,.5082,1.0145,1.9666,.8623,2.29311-.2245,.09269-.3085,.204-.612,.33389-.9088,.0345,.0675,.0712,.1336,.1098,.1983,.6214,1.0417,2.2746,.6585,2.3004-.5541,.0081-.3829,.0517-.7658,.1311-1.1438l.0167,.0269c.5689,.9135,1.9939,.6366,2.2212-.4154,1.0032-4.6415,6.6597-8.128,11.7708-6.0526l3.6879,2.1903c4.2267-2.4704,5.8516-8.08,5.8516-8.08Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "617.90839 390.4785 617.32629 394.3803 600.12209 399.5588 604.08689 402.1004 621.114 397.3671 621.81569 389.7869 617.90839 390.4785",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M630.76209,302.8783c-7.725-4.9531-21.3388-2.5982-21.3388-2.5982l-24.97129,15.2379,17.07529,40.1362s7.1262,17.0699,10.9698,28.4375c.9524,2.8168,2.7742,6.7455,5.7225,6.3605l47.42941-8.5748c2.318-.4191,3.782-2.7311,3.15359-5.0014-4.5779-16.5381-31.1217-69.5615-38.0405-73.9977Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.21969,325.2023s-7.6002,14.3078-20.9451,26.7828c-5.3894,5.038-9.1315,12.3019-9.1315,12.3019l-3.3465-8.5474,33.4231-30.5373Z",
    style: {
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M611.70829,314.1755l-32.3325,40.3176-37.9604,17.2339,3.7843,15.7128s30.7789-8.3049,43.14931-16.0142c12.37039-7.7092,32.765-29.266,32.765-29.266,0,0,17.78589-14.2742,16.93729-25.8219-.8486-11.5476-17.778-14.2446-26.343-2.1622Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.15629,309.5963s1.2005-6.1591,1.7828-5.9113c.5823,.2479,6.36191,3.7176,6.36191,3.7176l6.46409-9.6839,3.8803,2.5669-8.9297,18.5129-9.5594-9.2022Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "591.31719 335.4356 583.86089 325.2023 589.88479 341.2265 592.818 338.1065 613.40629 312.0818 591.31719 335.4356",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.15629,309.5963c.326,.1166,5.6801,3.7264,5.3876,3.7855-.2926,.0592,2.2527-4.3176,2.2527-4.3176l5.676,2.1591,4.6591-11.2775-4.586,12.9902-5.3765-2.5995-2.6253,4.7606-5.3876-5.5008Z",
    style: {
      opacity: 0.4
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character_1--inject-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M225.7224,232.9484c.0549-1.0049-.0597-2.0098-.4149-2.963-1.21-3.2475-4.6618-5.1798-6.1381-8.3152-2.178-4.6259,.8918-10.3893,5.3933-12.8142,3.492-1.8808,5.3207-2.2339,8.3378-2.0613,3.0172-.1726,4.8458,.1805,8.3379,2.0613,4.5015,2.4249,7.5713,8.1883,5.3932,12.8142-1.4761,3.1354-4.9279,5.0677-6.138,8.3152-.3552,.9532-.4699,1.9581-.415,2.963h45.9256v-46.2937c1.8651-.7086,3.9072-.885,5.7597-.1946,3.2475,1.21,5.1797,4.6618,8.3151,6.1381,4.6259,2.178,10.3894-.8917,12.8142-5.3933,1.8809-3.4921,2.2339-5.3207,2.0614-8.3379,.1725-3.0171-.1805-4.8458-2.0614-8.3378-2.4248-4.5015-8.1883-7.5714-12.8142-5.3932-3.1354,1.4763-5.0676,4.928-8.3151,6.138-1.8525,.6903-3.8946,.5139-5.7597-.1947v-41.168l-102.6807-.4591v103.0371l42.3989,.4591Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M225.7224,232.9484c.0549-1.0049-.0597-2.0098-.4149-2.963-1.21-3.2475-4.6618-5.1798-6.1381-8.3152-2.178-4.6259,.8918-10.3893,5.3933-12.8142,3.492-1.8808,5.3207-2.2339,8.3378-2.0613,3.0172-.1726,4.8458,.1805,8.3379,2.0613,4.5015,2.4249,7.5713,8.1883,5.3932,12.8142-1.4761,3.1354-4.9279,5.0677-6.138,8.3152-.3552,.9532-.4699,1.9581-.415,2.963h45.9256v-46.2937c1.8651-.7086,3.9072-.885,5.7597-.1946,3.2475,1.21,5.1797,4.6618,8.3151,6.1381,4.6259,2.178,10.3894-.8917,12.8142-5.3933,1.8809-3.4921,2.2339-5.3207,2.0614-8.3379,.1725-3.0171-.1805-4.8458-2.0614-8.3378-2.4248-4.5015-8.1883-7.5714-12.8142-5.3932-3.1354,1.4763-5.0676,4.928-8.3151,6.138-1.8525,.6903-3.8946,.5139-5.7597-.1947v-41.168l-102.6807-.4591v103.0371l42.3989,.4591Z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M228.835,232.9484c.0549-1.0049-.0597-2.0098-.4149-2.963-1.2099-3.2475-4.6617-5.1798-6.1381-8.3152-2.178-4.6259,.8918-10.3893,5.3933-12.8142,3.492-1.8808,5.3207-2.2339,8.3378-2.0613,3.0172-.1726,4.8458,.1805,8.3379,2.0613,4.5016,2.4249,7.5714,8.1883,5.3932,12.8142-1.4761,3.1354-4.9278,5.0677-6.1379,8.3152-.3552,.9532-.47,1.9581-.4151,2.963h45.9257v-46.2937c1.8651-.7086,3.9072-.885,5.7596-.1946,3.2476,1.21,5.1798,4.6618,8.3152,6.1381,4.6259,2.178,10.3894-.8917,12.8142-5.3933,1.8808-3.4921,2.2339-5.3207,2.0613-8.3379,.1726-3.0171-.1805-4.8458-2.0613-8.3378-2.4248-4.5015-8.1883-7.5714-12.8142-5.3932-3.1354,1.4763-5.0676,4.928-8.3152,6.138-1.8524,.6903-3.8945,.5139-5.7596-.1947v-41.168l-102.6808-.4591v103.0371l42.3989,.4591Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M160.5646,177.7963s-7.4977,26.5638-2.7022,31.188c4.7956,4.6242,21.5798,1.5414,20.7235,1.1989-.8564-.3426,4.2816-32.2894,4.6242-31.1306,.3425,1.1586-22.6455-1.2563-22.6455-1.2563Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M169.8928,417.6482l-.023,23.045,10.7004,.8317,3.7608-21.6492c-4.894-3.5344-9.7096-4.3781-14.4382-2.2275Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.7743,438.2884c-1.0528,3.0411-1.1218,15.4851-1.1218,15.4851l22.6812,.0265c1.3475-4.5-.7378-7.5717-3.3831-7.9795-1.1369-.1735-2.4741-1.4379-3.449-2.542-.0066-.1431-1.3937-7.0556-2.2506-7.3863,0,0-.5907-.7189-1.0941-.0011-.5032,.7173-.9396,3.0532-.9396,3.0532-3.5405-4.7598-7.0103-4.1243-10.443-.6559Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.4993,441.901c2.5628-1.0227,5.3129-.6341,7.5473,1.0658,.391,.2976,.7619-.3982,.374-.6932-2.3805-1.8111-5.3889-2.236-8.1183-1.1465-.4439,.177-.2522,.9533,.197,.7739h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.2655,451.98h-.0003l-22.3475-.0261c-.2047-.0003-.3705-.1801-.3702-.402,.0001-.2214,.1662-.401,.3706-.401h.0003l22.3476,.0262c.2046,.0002,.3705,.1801,.3702,.4021-.0003,.2211-.1662,.4008-.3707,.4008Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M216.0553,414.643l-.0262,26.009,10.2956,.8495,5.065-24.3457c-4.1335-3.3268-8.9339-4.9565-15.3344-2.5128Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.5633,438.342c-1.0529,3.0411-1.1218,15.4851-1.1218,15.4851l26.0568,.0308c1.3475-4.5002-1.4681-7.1678-4.1134-7.5757-1.1369-.1735-5.1196-1.8459-6.0945-2.9501-.0065-.1431-1.3935-7.0555-2.2505-7.3861,0,0-.5907-.7189-1.0939-.0013-.5033,.7175-.9396,3.0534-.9396,3.0534-3.5406-4.76-7.0103-4.1243-10.4431-.6561Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.2882,441.9549c2.5627-1.0228,5.3129-.6342,7.5473,1.0655,.3911,.2977,.7621-.3981,.3741-.6931-2.3804-1.8111-5.3891-2.2359-8.1185-1.1466-.4438,.1773-.2518,.9533,.1971,.7742h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.5004,452.0378h-.0003l-25.7937-.0304c-.2046-.0002-.3703-.1801-.3701-.4018,.0002-.2214,.1661-.4009,.3707-.4009h.0003l25.7936,.0303c.2047,.0001,.3705,.1799,.3702,.4019-.0002,.2213-.1661,.4009-.3707,.4009Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M165.456,429.0047l22.8018,1.2139c5.1156-16.5791,10.172-76.0253,10.6946-93.8723,.6244-21.3246,8.2597-74.8444,1.5085-85.9814s-37.2888-2.2672-37.2888-2.2672c0,0,3.8052,65.167,2.2839,85.9501-1.3182,18.0129-3.3581,70.9612,0,94.9569Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.7193 424.2124 189.2367 431.8302 164.5269 431.0275 163.621 423.7127 190.7193 424.2124",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.9954,429.0047l22.605,1.2139c2.7521-18.3533,13.8082-85.192,12.8998-97.9953-1.1094-15.6386-14.2016-83.3325-19.0703-88.5518-4.8687-5.2193-40.5133,8.3095-40.5133,8.3095,0,0,14.6493,58.2117,26.1999,83.3882,2.3996,5.2301-3.977,71.3135-2.1211,93.6355Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.1851 424.7831 235.0321 431.8302 209.9104 430.2186 209.4047 422.8415 236.1851 424.7831",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.1776 303.3024 194.5405 281.1168 182.7631 277.2727 191.9703 284.4115 199.3746 324.8496 201.1776 303.3024",
    style: {
      opacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M213.8796,106.8049c0,.957,.4197,1.6791,1.0243,1.7799,.6045,.1008,1.1587-.7052,1.2091-1.6792s-.403-1.6793-1.0076-1.78c-.6045-.1008-1.1083,.7557-1.2258,1.6793Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.2658,106.6705c.3355,3.0854,1.0985,6.1089,2.2671,8.984-1.514,.5565-3.1956,.4215-4.6013-.3695l2.3342-8.6145Z",
    style: {
      fill: "#a24e3f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.1499,103.7319c-.1236,.0122-.2478-.0173-.3526-.0841-.218-.2148-.2204-.5656-.0056-.7836l.0056-.0056c1.1205-1.3952,2.8487-2.1591,4.6346-2.0487,.2957,.0266,.514,.2875,.4876,.583l-.0005,.0048h0c-.0511,.2979-.3198,.5085-.6212,.4869h0c-1.4153-.0644-2.7738,.5615-3.6441,1.6793-.1266,.141-.3179,.2046-.5038,.168Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M214.2835,119.5159c-.1255,.5109-.2806,1.0145-.4641,1.5083-1.0271,2.8185-2.8964,5.2661-5.3627,7.022-.6203,.4473-1.2755,.8456-1.9596,1.1913-5.3726,2.8257-12.0013,1.7895-16.2176-2.5349-5.4275-5.3869-5.2856-11.6103-5.9045-22.1431-.1635-2.2635,.2117-4.5331,1.0959-6.6291,3.1091-7.3563,11.6951-10.8417,19.1771-7.7848l.0055,.0022c10.4679,4.2082,11.9119,19.8745,9.63,29.3681Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.4178,128.0462c-.62,.4473-1.2753,.8456-1.9595,1.1913-3.6354,1.906-7.9528,2.0925-11.7442,.5072,.4849-1.2662,1.1304-2.4672,1.9208-3.5744,4.0294-.4969,8.1191,.1542,11.7829,1.8759Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.8503,141.7098c5.2855,4.7151,18.2157,2.9786,18.2157,2.9786,0,0,8.0702-2.18,6.3685-4.6517-4.7441-.7732-7.0517-2.9532-8.0057-5.7545-.5149-1.7304-.6769-3.544-.4769-5.3361,.076-.9995,.2095-1.994,.3996-2.9787l-15.9856-11.6356c2.0884,7.681,4.6538,21.8137-.5156,27.378Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.4178,109.9336l2.3076,.8492-1.1473-4.6391s3.3776-5.0699,0-9.4682c0,0,9.3336-2.7885,4.0609-7.605-1.9596-1.7999-4.3961,0-10.8419-2.7505-3.4936-1.5083-14.4257-1.6224-14.9672,2.7505,0,0-7.8767,0-8.7275,13.182-.5036,7.8188,2.5524,15.4535,8.3408,20.8377,0,0,9.514,2.2054,14.1808-1.5463,4.6667-3.7519,6.7938-11.6103,6.7938-11.6103Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.3331,110.6814c.4074,2.0071,1.7149,3.7259,3.558,4.6771,2.1788,.9126,3.6225-2.1041,3.3003-5.2728-.2965-2.8139-1.7792-6.7685-4.1125-6.2362-2.3333,.5325-3.5065,3.9927-2.7458,6.8319Z",
    style: {
      fill: "#b97964"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M170.5953,139.1759s-3.7142,1.1293-5.5621,1.8064c-3.8515,1.411-6.3937,5.6988-7.7876,9.9088-3.406,10.2874-8.9103,34.6417-8.9103,34.6417l19.9731,4.1976,10.6545-22.9461-8.3676-27.6084Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.5953,139.1759s-5.3449,.9947-8.1585,3.3192c-2.1414,1.7694-3.8467,4.3352-5.1912,8.396-3.406,10.2874-8.9103,34.6417-8.9103,34.6417l19.9731,4.1976,10.6545-22.9461-8.3676-27.6084Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.9673,140.3566c-5.8913-.6344-24.0121-4.7284-48.372-1.1807l-5.7004,90.0708s-.7318,13.7799-2.8899,25.6053c24.7556,10.6298,54.042,7.5901,70.602-1.3461-.1917,.3757-.7341-9.4527-1.5834-23.8495-1.4968-25.3704-3.9461-64.9274-7.1062-87.829-.0859-.5658-4.363-1.4075-4.9501-1.4708Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.9673,140.3566c-5.8913-.6344-24.0121-4.7284-48.372-1.1807l-5.7004,90.0708s-.7318,13.7799-2.8899,25.6053c24.7556,10.6298,54.042,7.5901,70.602-1.3461-.1917,.3757-.7341-9.4527-1.5834-23.8495-1.4968-25.3704-3.9461-64.9274-7.1062-87.829-.0859-.5658-4.363-1.4075-4.9501-1.4708Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M186.5819,138.239c.7038-2.0935,1.6837-3.5666,2.9398-4.4193l13.5655,1.0457,6.3605,4.1934-22.8658-.8198Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.5819,138.2393c.7037-2.0935,1.6836-3.5668,2.9397-4.4194l13.5656,1.0455,6.3605,4.1931-22.8658-.8192Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M218.3358,168.391c2.1724,10.1447,5.2957,30.0323,11.1902,36.9634l-1.4011-20.127-9.7891-16.8364Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.038 189.4507 167.5634 163.4384 162.1029 188.2135 167.038 189.4507",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M228.7355,176.4147c-.7614,.2928,13.9289,33.3448,19.9101,33.6401,5.9812,.2951,34.0624-12.4834,34.0624-12.4834l-6.3002-7.5198-21.2245,1.2172-10.8252-23.0439-15.6226,8.1898Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M221.3488,141.4905c-7.6187,5.032-11.3947,16.4248,9.0304,51.6012l22.0573-13.4699c-4.462-8.232-9.1893-14.2173-14.4426-26.1398-10.5902-15.2455-16.6451-11.9915-16.6451-11.9915Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.3488,141.4905c-7.6187,5.032-11.3947,16.4248,9.0304,51.6012l22.0573-13.4699c-4.462-8.232-9.1893-14.2173-14.4426-26.1398-10.5902-15.2455-16.6451-11.9915-16.6451-11.9915Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M292.5999,189.8288c0-1.9289-.5936-4.0261-1.632-4.0901-1.0386-.0641-6.586-.0063-6.586-.0063h0c0-1.5567,2.9202-3.2595,1.9686-4.3231-1.241-1.387-8.43,4.5392-8.8837,5.7489-.8902,2.3738-1.3353,2.9673-1.3353,2.9673l3.7997,8.7208s7.0308,4.6319,8.6629,2.9999c1.632-1.6319,1.4835-3.3761,1.4835-3.3761,0,0,1.6321-2.2617,1.4837-3.7454-.1484-1.4836,1.0386-2.9672,1.0386-4.8959Z",
    style: {
      fill: "#b97964"
    }
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamHeroCropped);
export default __webpack_public_path__ + "static/media/teamHero-cropped.8220d4ee7313fc6c562c1ef9dec64598.svg";
export { ForwardRef as ReactComponent };